import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  Table
} from 'react-lib/frameworks/Table'
import {
  Button,
  Dropdown,
  Input,
  Checkbox,
  FormGroup,
  FormField,
  Form
} from 'semantic-ui-react'

const CardMedReconcileUX = (props: any) => {
    return(
      <div
        id="CardMedReconcileUX-div-0"
        style={{padding: "5px"}}>
        <div
          id="CardMedReconcileUX-div-1"
          style={{display: "flex", justifyContent: "space-between"}}>
          
          <div
            id="CardMedReconcileUX-div-135"
            style={{fontWeight: "bold", fontSize: "1.3rem", padding: "5px"}}>
            {props.languageUX === "en" ? "Medication Reconcilliation" : "การตรวจสอบการใช้ยา"}
          </div>
          <div
            id="CardMedReconcileUX-div-134"
            style={{display: "flex",  paddingTop: "10px", textAlign: "right"}}>
            
            <div
              id="CardMedReconcileUX-div-136">
              
              <Button
                id="CardMedReconcileUX-Button-138"
                onClick={props.onShowMedReconcileList}>
                {props.languageUX === "en" ? "เลือกใบ Medication Reconciliation" : "เลือก Medication Reconciliation"}
              </Button>
              <div
                id="CardMedReconcileUX-div-141"
                style={{display: props.showMedReconcileList? "block": "none", position: "absolute", zIndex: 100, padding: "10px", backgroundColor: "#FFF", right:"10%"}}>
                
                <Table
                  data={props.medReconcileList}
                  getTrProps={props.getTrPropsMedReconcileList}
                  headers="Type,Encounter,วันที่และเวลาสร้าง"
                  id="CardMedReconcileUX-Table-142"
                  keys="med_reconciliation_type_label,name,created_datetime"
                  minRows="3"
                  showPagination={false}
                  style={{height: "250px", width: "600px", textAlign: "center"}}
                  widths="150,,200">
                </Table>
                <div
                  id="CardMedReconcileUX-div-143"
                  style={{paddingTop: "5px", display: "flex", justifyContent: props.enableNewButtonInMedReconcileList ? "space-between" : "flex-end"}}>
                  
                  <Button
                    color="green"
                    id="CardMedReconcileUX-Button-144"
                    onClick={props.onNewMedReconcile}
                    style={{...(!props.enableNewButtonInMedReconcileList && {display: "none"})}}>
                    {props.languageUX === "en" ? "New" : "ใหม่"}
                  </Button>
                  <Button
                    color="blue"
                    id="CardMedReconcileUX-Button-145"
                    onClick={props.onMedReconcileSelect}>
                    {props.languageUX === "en" ? "choose" : "เลือก"}
                  </Button>
                </div>
              </div>
            </div>
            <div
              id="CardMedReconcileUX-div-137">
              
              <Dropdown
                disabled={!!props.disabledMedReconcileType}
                id="CardMedReconcileUX-Dropdown-139"
                onChange={props.changeMedReconcileType}
                options={props.medReconcileTypeOptions}
                selection={true}
                style={{transform: "scale(0.85)"}}
                value={props.medReconcileType}>
              </Dropdown>
            </div>
          </div>
        </div>
        <div
          id="CardMedReconcileUX-div-146"
          style={{display: props.medReconcileType === "DISCHARGE" ||  props.medReconcileType === "TRANSFER" ?"none":"flex", flexDirection: "column"}}>
          
          <Checkbox
            checked={props.hasNoPastMed}
            disabled={props.disabledNoPastMed}
            id="CardMedReconcileUX-Checkbox-147"
            label={props.languageUX === "en" ? "No original medication list" : "ไม่มีรายการยาเดิม"}
            onChange={props.changeHasNoPastMed}
            style={{padding: "10px", width: "fit-content"}}>
          </Checkbox>
          <Checkbox
            checked={props.notAvailableAtAdmit}
            disabled={props.notAvailableDisabled}
            id="CardMedReconcileUX-Checkbox-149"
            label={`Not Available at time of admission will be completed in ${props.configMedReconcileAvailable} hour(s). ${props.limitDateTime}`}
            onChange={props.changeNotAvailableAtAdmit}
            style={{padding: "10px", width: "fit-content"}}>
          </Checkbox>
        </div>
        <div
          id="CardMedReconcileUX-div-2"
          style={{display: "none"}}>
          
          <div
            id="CardMedReconcileUX-div-7"
            style={{marginTop: "10px"}}>
            {props.languageUX === "en" ? "From the history of drug orders from the hospital" : "จากประวัติการสั่งยาจากโรงพยาบาล"}
          </div>
          <Table
            data={props.internalItems}
            headers="รหัสยา,ชื่อยาและความแรง,วิธีใช้,QTY,Start Date,Time,Last Date,Time,Note,Off Hold Cont.,"
            id="CardMedReconcileUX-Table-8"
            keys="code,name,label,quantity,start_date,start_time,last_dose_date,last_dose_time,note,_action,remove"
            minRows="6"
            showPagination={false}
            style={{height: "150px"}}>
          </Table>
        </div>
        <div
          id="CardMedReconcileUX-div-3"
          style={{display: "none"}}>
          
          <div
            id="CardMedReconcileUX-div-9"
            style={{marginTop: "10px"}}>
            {props.languageUX === "en" ? "History of drug use outside hospital" : "ประวัติการใช้ยานอกโรงพยาบาล"}
          </div>
          <Table
            data={props.externalItems}
            getTrProps={props.externalRowProps}
            headers="ประเภท,ชื่อ,QTY,Start Date,Time,Last Date,Time,Note,Off Hold Cont.,"
            id="CardMedReconcileUX-Table-15"
            keys="typeName,name,quantity,start_date,start_time,last_dose_date,last_dose_time,note,_action,remove"
            minRows="6"
            showPagination={false}
            style={{height: "150px"}}>
          </Table>
        </div>
        <div
          id="CardMedReconcileUX-div-4"
          style={{...(props.medReconcileType === "TRANSFER" && {display: "none"}), marginTop: "10px", borderBottom: "solid #cccccc 1px"}}>
          
          <Button
            color={props.external ? null : "blue"}
            id="CardMedReconcileUX-Button-13"
            onClick={props.setInternal}
            size="small">
            {props.medReconcileType === "DISCHARGE" ? "เลือกรายการยาจาก Medication Reconciliation แรกรับ":" เพิ่มจากประวัติการสั่งยาจากโรงพยาบาล"}
          </Button>
          <Button
            color={props.external ? "blue" :  null}
            id="CardMedReconcileUX-Button-14"
            onClick={props.setExternal}
            size="small">
            {props.externalNameBtn}
          </Button>
        </div>
        <div
          id="CardMedReconcileUX-div-5"
          style={{...(props.medReconcileType === "TRANSFER" && {display: "none"})}}>
          
          <div
            id="CardMedReconcileUX-div-11"
            style={{display: !props.external && props.medReconcileType !== "DISCHARGE" ?  "block" : "none", height: "350px"}}>
            
            <div
              className="ui form search-order-history"
              id="CardMedReconcileUX-div-183"
              style={{ marginTop: "1rem"  }}>
              {}
              <FormGroup
                id="CardMedReconcileUX-FormGroup-184"
                inline={true}
                widths={16}>
                <FormField
                  id="CardMedReconcileUX-FormField-185"
                  inline={true}>
                  <Checkbox
                    checked={props.checkedDoctor}
                    id="CardMedReconcileUX-Checkbox-196"
                    label={props.languageUX === "en" ? "Physician name or code" : "ชื่อหรือรหัสแพทย์"}
                    onChange={props.changeCheckedDoctor}
                    style={{width: "100%", minWidth: "max-content"}}>
                  </Checkbox>
                </FormField>
                <FormField
                  id="CardMedReconcileUX-FormField-186"
                  inline={true}
                  width={4}>
                  <div
                    id="CardMedReconcileUX-div-199"
                    style={{width: "100%"}}>
                    {props.searchDoctor}
                  </div>
                </FormField>
                <FormField
                  id="CardMedReconcileUX-FormField-187"
                  inline={true}>
                  <Checkbox
                    checked={props.checkedDrug}
                    id="CardMedReconcileUX-Checkbox-197"
                    label={props.languageUX === "en" ? "Drug name or code" : "ชื่อหรือรหัสยา"}
                    onChange={props.changeCheckedDrug}
                    style={{width: "100%",minWidth: "max-content"}}>
                  </Checkbox>
                </FormField>
                <FormField
                  id="CardMedReconcileUX-FormField-188"
                  inline={true}
                  width={4}>
                  <div
                    id="CardMedReconcileUX-div-200"
                    style={{width: "100%"}}>
                    {props.searchDrug}
                  </div>
                </FormField>
                <FormField
                  id="CardMedReconcileUX-FormField-189"
                  inline={true}>
                  <Checkbox
                    checked={props.checkedDateInternal}
                    id="CardMedReconcileUX-Checkbox-198"
                    label={props.languageUX === "en" ? "Date of prescription" : "วันที่สั่งยา"}
                    onChange={props.changeCheckedDateInternal}
                    style={{width: "100%",minWidth: "max-content"}}>
                  </Checkbox>
                </FormField>
                <FormField
                  id="CardMedReconcileUX-FormField-190"
                  inline={true}>
                  <div
                    id="CardMedReconcileUX-div-195"
                    style={{width: "100%"}}>
                    {props.startDateInternal}
                  </div>
                </FormField>
                <FormField
                  id="CardMedReconcileUX-FormField-191"
                  inline={true}>
                  <div
                    id="CardMedReconcileUX-div-194"
                    style={{width: "100%"}}>
                    {props.endDateInternal}
                  </div>
                </FormField>
                <FormField
                  id="CardMedReconcileUX-FormField-192"
                  inline={true}>
                  <Button
                    color="blue"
                    fluid={true}
                    id="CardMedReconcileUX-Button-193"
                    loading={props.medReconcileLoading}
                    onClick={props.onSearchOrderHistory}
                    size="tiny"
                    style={{width: "100%"}}>
                    {props.languageUX === "en" ? "Search" : "ค้นหา"}
                  </Button>
                </FormField>
              </FormGroup>
            </div>
            <Form
              id="CardMedReconcileUX-Form-201">
              <Table
                data={props.drugOrderHistoryItems}
                getTrProps={props.drugOrderHistoryTrProps}
                headers=",รหัสยา,ชื่อยา,จำนวนจ่าย,แพทย์,วันที่,หน่วยงาน"
                id="CardMedReconcileUX-Table-202"
                keys="_add,code,product_name,quantity,order_by_name,order_time,order_div_name"
                minRows={5}
                showPagination={false}
                style={{height:"250px"}}
                widths="^50,^100,^200,^90,^100,^90,^100">
              </Table>
            </Form>
            <Form
              id="CardMedReconcileUX-Form-203">
              <FormGroup
                id="CardMedReconcileUX-FormGroup-205"
                inline={true}
                style={{marginTop: "1rem"}}
                widths={16}>
                <FormField
                  id="CardMedReconcileUX-FormField-206"
                  style={{flex:1}}>
                </FormField>
                <FormField
                  id="CardMedReconcileUX-FormField-207">
                  <Button
                    color="green"
                    disabled={props.disabledAddFromInternal}
                    id="CardMedReconcileUX-Button-208"
                    onClick={props.onAddInternalItem}>
                    {props.languageUX === "en" ? "Add" : "เพิ่ม"}
                  </Button>
                </FormField>
              </FormGroup>
            </Form>
          </div>
          <div
            id="CardMedReconcileUX-div-165"
            style={{display: !props.external && props.medReconcileType === "DISCHARGE" ?  "block" : "none", height: "280px"}}>
            
            <div
              id="CardMedReconcileUX-div-166">
              
              <Table
                data={props.drugIPDAdmit}
                headers=",รหัสยา, ชื่อยาและความแรง, วิธีใช้, QTY, Start Date, Time, Last Date, Time, Note,Off,Hold,Cont."
                id="drugIPDAdmit"
                keys="_add,code,nameDiv,label,quantity, start_date_text, start_time_text, last_date_text, last_time_text, btn_note,_action_off,_action_hold,_action_cont"
                minRows="5"
                showPagination={false}
                style={{height:"220px"}}
                widths="80,80,,200,50,100,80,100,80,100,60,60,60">
              </Table>
            </div>
            <div
              id="CardMedReconcileUX-div-167"
              style={{display: "flex", justifyContent: "flex-end", marginTop: "10px"}}>
              
              <Button
                color="green"
                disabled={props.medReconcileIPDAdmitSelectOrder?.length === 0 && props.medReconcileIPDAdmitSelectItem?.length === 0}
                id="CardMedReconcileUX-Button-169"
                onClick={props.onAddDrugToMRDischarge}>
                {props.languageUX === "en" ? "Add to MR discharge List" : "เพิ่มเข้ารายการปล่อย MR"}
              </Button>
            </div>
          </div>
          <div
            id="CardMedReconcileUX-div-12"
            style={{display: props.external ? "block" : "none", height: "300px"}}>
            
            <div
              id="CardMedReconcileUX-div-18"
              style={{"width":"100%","height":"100%","display":"grid","position":"relative","gridTemplateRows":"repeat(14, 1fr)","gridTemplateColumns":"repeat(50, 1fr)"}}>
              <div
                id="CardMedReconcileUX-div-56"
                style={{gridRow: "2/3", gridColumn: "3/6", }}>
                {props.languageUX === "en" ? "type" : "ประเภท"}
              </div>
              <div
                id="CardMedReconcileUX-div-57"
                style={{ gridRow: "10/11", gridColumn: "3/50",}}>
                
                <Form
                  id="CardMedReconcileUX-Form-279">
                  <FormGroup
                    id="CardMedReconcileUX-FormGroup-280"
                    widths={16}>
                    <FormField
                      id="CardMedReconcileUX-FormField-281"
                      style={{marginRight: "0.55rem"}}>
                      <label
                        id="CardMedReconcileUX-label-285"
                        style={{fontWeight: "normal"}}>
                        {props.languageUX === "en" ? "Start Date" : "วันที่เริ่มต้น"}
                      </label>
                      <div
                        id="CardMedReconcileUX-div-286"
                        style={{width: "100%"}}>
                        {props.startDateElement}
                      </div>
                    </FormField>
                    <FormField
                      id="CardMedReconcileUX-FormField-282"
                      style={{marginRight: "0.55rem"}}>
                      <label
                        id="CardMedReconcileUX-label-287"
                        style={{fontWeight: "normal"}}>
                        {props.languageUX === "en" ? "Time" : "เวลา"}
                      </label>
                      <div
                        id="CardMedReconcileUX-div-290">
                        {props.StartTimeFreeTextBox}
                      </div>
                    </FormField>
                    <FormField
                      id="CardMedReconcileUX-FormField-283"
                      style={{marginRight: "0.55rem"}}>
                      <label
                        id="CardMedReconcileUX-label-288"
                        style={{fontWeight: "normal"}}>
                        {props.languageUX === "en" ? "Last Date" : "วันที่สุดท้าย"}
                      </label>
                      <div
                        id="CardMedReconcileUX-div-291"
                        style={{width: "100%"}}>
                        {props.endDateElement}
                      </div>
                    </FormField>
                    <FormField
                      id="CardMedReconcileUX-FormField-284">
                      <label
                        id="CardMedReconcileUX-label-289"
                        style={{fontWeight: "normal"}}>
                        {props.languageUX === "en" ? "Time" : "เวลา"}
                      </label>
                      <div
                        id="CardMedReconcileUX-div-292">
                        {props.EndTimeFreeTextBox}
                      </div>
                    </FormField>
                  </FormGroup>
                </Form>
              </div>
              <div
                id="CardMedReconcileUX-div-59"
                style={{ padding: "5px", textAlign: "right", gridRow: "11/13", gridColumn: "2/6", }}>
                
              </div>
              <div
                id="CardMedReconcileUX-div-60"
                style={{ gridRow: "3/5", gridColumn: "3/13", }}>
                <Dropdown
                  disabled={props.disableDrugType}
                  fluid={true}
                  id="CardMedReconcileUX-Dropdown-73"
                  onChange={props.changeExternalType}
                  options={props.externalTypeOptions}
                  selection={true}
                  style={{width: "100%"}}
                  value={props.externalType}>
                </Dropdown>
              </div>
              <div
                id="CardMedReconcileUX-div-67"
                style={{ gridRow: "12/14", gridColumn: "3/14", }}>
                <Checkbox
                  checked={props.checkedUnknowLastDose}
                  disabled={props.disabledUnknowLastDose}
                  id="CardMedReconcileUX-Checkbox-122"
                  label={props.languageUX === "en" ? "Last dose cannot be specified" : "ไม่สามารถระบุ Last dose"}
                  onChange={props.changeUnknowLastDose}
                  style={{padding: "5px", marginTop:"0.25rem"}}>
                </Checkbox>
              </div>
              <div
                id="CardMedReconcileUX-div-68"
                style={{ gridRow: "12/14", gridColumn: "31/41", justifyContent:"flex-end", display: "flex"}}>
                <Button
                  color="green"
                  disabled={props.disabledAddUpdateBtn}
                  id="CardMedReconcileUX-Button-70"
                  onClick={props.addOtherDrug}
                  size="small"
                  style={{width: "fit-content", height: "100%"}}>
                  {props.languageUX === "en" ? "Add/Update this item" : "เพิ่ม/อัพเดทรายการนี้"}
                </Button>
              </div>
              <div
                id="CardMedReconcileUX-div-78"
                style={{ gridRow: "2/3", gridColumn: "14/20", }}>
                {props.languageUX === "en" ? "Name/Details" : "ชื่อ/รายละเอียด"}
              </div>
              <div
                id="CardMedReconcileUX-div-79"
                style={{ gridRow: "3/5", gridColumn: "14/28", }}>
                {props.externalDrug}
              </div>
              <div
                id="CardMedReconcileUX-div-80"
                style={{gridRow: "2/3", gridColumn: "29/32", }}>
                {props.languageUX === "en" ? "Qty" : "จำนวน"}
              </div>
              <div
                id="CardMedReconcileUX-div-81"
                style={{ gridRow: "3/5", gridColumn: "29/36",}}>
                <Input
                  disabled={props.disabledQty}
                  fluid={true}
                  id="CardMedReconcileUX-Input-82"
                  min={0}
                  onChange={props.changeQty}
                  style={{height: "100%"}}
                  type="number"
                  value={props.qty}>
                </Input>
              </div>
              <div
                id="CardMedReconcileUX-div-83"
                style={{ gridRow: "12/14", gridColumn: "42/48", border: "solid 1px rgb(200, 200, 200, 0.5)" }}>
                <Button
                  color="orange"
                  id="CardMedReconcileUX-Button-84"
                  onClick={props.clearExternalDrug}
                  size="small"
                  style={{width: "100%", height: "100%"}}>
                  {props.languageUX === "en" ? "clear" : "เคลียร์"}
                </Button>
              </div>
              <div
                id="CardMedReconcileUX-div-85"
                style={{ gridRow: "6/7", gridColumn: "3/6"}}>
                
                <label
                  id="CardMedReconcileUX-label-155">
                  {props.languageUX === "en" ? "Dose" : "ปริมาณยา"}
                </label>
              </div>
              <div
                id="CardMedReconcileUX-div-86"
                style={{ gridRow: "7/9", gridColumn: "3/9"}}>
                <Input
                  disabled={props.disabledDrugQty}
                  fluid={true}
                  id="CardMedReconcileUX-Input-97"
                  min={0}
                  onChange={props.changeDose}
                  type="number"
                  value={props.dose}>
                </Input>
              </div>
              <div
                id="CardMedReconcileUX-div-87"
                style={{ gridRow: "6/7", gridColumn: "10/12"}}>
                {props.languageUX === "en" ? "Unit" : "หน่วย"}
              </div>
              <div
                id="CardMedReconcileUX-div-88"
                style={{ gridRow: "7/9", gridColumn: "10/17"}}>
                <Dropdown
                  disabled={props.disabledUnit}
                  fluid={true}
                  id="CardMedReconcileUX-Dropdown-98"
                  onChange={props.changeUnit}
                  options={props.unitOptions}
                  search={true}
                  selection={true}
                  style={{height: "auto"}}
                  value={props.unit}>
                </Dropdown>
              </div>
              <div
                id="CardMedReconcileUX-div-89"
                style={{ gridRow: "6/7", gridColumn: "18/20"}}>
                {props.languageUX === "en" ? "Route" : "ช่องทาง"}
              </div>
              <div
                id="CardMedReconcileUX-div-90"
                style={{ gridRow: "7/9", gridColumn: "18/25"}}>
                <Dropdown
                  disabled={props.disabledRoute}
                  fluid={true}
                  id="CardMedReconcileUX-Dropdown-99"
                  onChange={props.changeRoute}
                  options={props.routeOptions}
                  search={true}
                  selection={true}
                  value={props.route}>
                </Dropdown>
              </div>
              <div
                id="CardMedReconcileUX-div-91"
                style={{ gridRow: "6/7", gridColumn: "26/28"}}>
                {props.languageUX === "en" ? "Site" : "ตำแหน่ง"}
              </div>
              <div
                id="CardMedReconcileUX-div-92"
                style={{ gridRow: "7/9", gridColumn: "26/33"}}>
                <Dropdown
                  disabled={props.disabledSite}
                  fluid={true}
                  id="CardMedReconcileUX-Dropdown-100"
                  onChange={props.changeSite}
                  options={props.siteOptions}
                  search={true}
                  selection={true}
                  value={props.site}>
                </Dropdown>
              </div>
              <div
                id="CardMedReconcileUX-div-93"
                style={{ gridRow: "6/7", gridColumn: "34/37",}}>
                {props.languageUX === "en" ? "Frequency" : "ความถี่"}
              </div>
              <div
                id="CardMedReconcileUX-div-94"
                style={{ gridRow: "7/9", gridColumn: "34/42"}}>
                <Dropdown
                  disabled={props.disableFrequency}
                  fluid={true}
                  id="CardMedReconcileUX-Dropdown-101"
                  onChange={props.changeFrequency}
                  options={props.frequencyOptions}
                  search={true}
                  selection={true}
                  value={props.frequency}>
                </Dropdown>
              </div>
              <div
                id="CardMedReconcileUX-div-95"
                style={{ gridRow: "6/7", gridColumn: "43/45"}}>
                {props.languageUX === "en" ? "Method" : "วิธี"}
              </div>
              <div
                id="CardMedReconcileUX-div-96"
                style={{ gridRow: "7/9", gridColumn: "43/50"}}>
                <Dropdown
                  disabled={props.disabledMethod}
                  fluid={true}
                  id="CardMedReconcileUX-Dropdown-102"
                  onChange={props.changeMethod}
                  options={props.methodOptions}
                  search={true}
                  selection={true}
                  value={props.method}>
                </Dropdown>
              </div>
              <div
                id="CardMedReconcileUX-div-103"
                style={{ gridRow: "2/3", gridColumn: "37/40"}}>
                {props.languageUX === "en" ? "Note" : "บันทึก"}
              </div>
              <div
                id="CardMedReconcileUX-div-104"
                style={{ gridRow: "3/5", gridColumn: "37/50"}}>
                <Input
                  disabled={props.disabledNote}
                  fluid={true}
                  id="CardMedReconcileUX-Input-105"
                  onChange={props.changeNote}
                  style={{height: "100%"}}
                  value={props.note}>
                </Input>
              </div>
              <div
                id="CardMedReconcileUX-div-118"
                style={{ gridRow: "12/14", gridColumn: "12/20", display:  props.checkedUnknowLastDose? "block": "none"}}>
                <Dropdown
                  id="CardMedReconcileUX-Dropdown-120"
                  onChange={props.changeReason}
                  options={props.reasonOptions}
                  selection={true}
                  value={props.reason}>
                </Dropdown>
              </div>
              <div
                id="CardMedReconcileUX-div-119"
                style={{ gridRow: "12/14", gridColumn: "21/33", display:  props.reason === "etc"? "block": "none"}}>
                <Input
                  fluid={true}
                  id="CardMedReconcileUX-Input-121"
                  onChange={props.changeOtherReason}
                  style={{height: "100%"}}
                  value={props.otherReason}>
                </Input>
              </div>
            </div>
          </div>
        </div>
        <div
          id="CardMedReconcileUX-div-157"
          style={{...(props.medReconcileType === "TRANSFER" && {display: "none"})}}>
          
          <div
            id="CardMedReconcileUX-div-170"
            style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
            
            <div
              id="CardMedReconcileUX-div-171"
              style={{margin: "10px 0px", fontSize: "16px", fontWeight: "bold", flex: 1}}>
              {props.medReconcileType === "DISCHARGE" ? "Home Medication" : `Past Medication ${props.pastMedRecordDate}`}
            </div>
            <div
              id="CardMedReconcileUX-div-172"
              style={{display: props.medReconcileType === "DISCHARGE" ? "flex" : "none", justifyContent: "space-evenly", alignItems: "center", flex: "1"}}>
              
              <Checkbox
                checked={props.checkedIPDHome}
                id="CardMedReconcileUX-Checkbox-173"
                label={props.languageUX === "en" ? "IPD Home" : "IPD Home"}
                onChange={props.onChangeCheckedIPDHome}>
              </Checkbox>
              <Checkbox
                checked={props.checkedMRIPD}
                id="CardMedReconcileUX-Checkbox-174"
                label={props.languageUX === "en" ? "MR IPD First Admission" : "MR IPD แรกรับ"}
                onChange={props.onChangeCheckedMRIPD}>
              </Checkbox>
              <Checkbox
                checked={props.checkedSuggestion}
                id="CardMedReconcileUX-Checkbox-175"
                label={props.languageUX === "en" ? "Suggestion" : "คำแนะนำ"}
                onChange={props.onChangeCheckedSuggestion}>
              </Checkbox>
            </div>
          </div>
          <Table
            className="--rt-tbody-overflow-y-hidden"
            data={props.medicationItems}
            getTrProps={props.medicationRowProps}
            headers={props.medReconcileType === "DISCHARGE"? "TYPE,รหัสยา, ชื่อยาและความแรง, วิธีใช้, QTY, Start Date, Time, Last Date, Time, Note,ใช้ยาต่อ,หยุดยา," : "TYPE,รหัสยา, ชื่อยาและความแรง, วิธีใช้, QTY, Start Date, Time, Last Date, Time, Note,Off,Hold,Cont.,Edited date / time,"}
            id="CardMedReconcileUX-Table-159"
            keys={props.medReconcileType === "DISCHARGE"? "isExternal,code, name, label,quantity, start_date_text, start_time_text, last_date_text, last_time_text, btn_note,_is_cont,_is_stop,delete" : "isExternal,code,name,label,quantity, start_date_text, start_time_text, last_date_text, last_time_text, btn_note,_action_off,_action_hold,_action_cont,edit_time,delete"}
            minRows="6"
            showPagination={false}
            style={{height: "300px"}}
            widths={props.medReconcileType === "DISCHARGE"? "120,80,,200,50,100,80,100,80,100,100,100,60" : "80,80,200,200,50,100,80,100,80,100,60,60,60,120,60"}>
          </Table>
        </div>
        <div
          id="CardMedReconcileUX-div-176"
          style={{...(props.medReconcileType !== "TRANSFER" && {display: "none"})}}>
          
          <Button
            color="purple"
            id="CardMedReconcileUX-Button-178"
            onClick={props.onClickSyncDrugTransfer}>
            {props.languageUX === "en" ? "Sync your medication list (must be acknowledged every time)" : "Sync รายการยา (ต้องรับทราบทุกครั้ง)"}
          </Button>
          <div
            id="CardMedReconcileUX-div-182"
            style={{fontWeight: "bolder", fontSize: "larger", margin: "20px 0px 5px 0px"}}>
            {props.languageUX === "en" ? "Current Medication (One Day)" : "ยาที่ใช้ในปัจจุบัน (1 วัน)"}
          </div>
          <Table
            data={props.transferOneDayData}
            getTdProps={props.transferOneDayTdProps}
            getTrProps={props.transferOneDayTrProps}
            headers="TYPE,รหัสยา,ชื่อยาและความแรง,วิธีใช้,QTY,Start Date,Time,Last Date,Time,Note,Off,On"
            id="CardMedReconcileUX-Table-179"
            keys="type, code, name, label, quantity, startDate, startTime, lastDoseDate, lastDoseTime,noteIcon,off,on"
            minRows="5"
            showPagination={false}
            widths="80,100,auto,auto,60,100,60,100,60,auto,60,60">
          </Table>
          <div
            id="CardMedReconcileUX-div-180"
            style={{fontWeight: "bolder", fontSize: "larger",margin: "20px 0px 5px 0px"}}>
            {props.languageUX === "en" ? "Current Medication (Continue)" : "ยาที่ใช้ในปัจจุบัน (ต่อ)"}
          </div>
          <Table
            data={props.transferContData}
            getTdProps={props.transferContTdProps}
            getTrProps={props.transferContTrProps}
            headers="TYPE,รหัสยา,ชื่อยาและความแรง,วิธีใช้,QTY,Start Date,Time,Last Date,Time,Note,Off,Hold,Cont"
            id="CardMedReconcileUX-Table-181"
            keys="type, code, name, label, quantity, startDate, startTime, lastDoseDate, lastDoseTime,noteIcon,off,hold,continue"
            minRows="5"
            showPagination={false}
            widths="80,100,auto,auto,60,100,60,100,60,auto,60,60,80">
          </Table>
        </div>
        <div
          id="CardMedReconcileUX-div-6"
          style={{ borderTop: "solid #cccccc 1px", marginBottom: "4rem", paddingTop: "1rem"}}>
          
          <Form
            id="CardMedReconcileUX-Form-219">
            <FormGroup
              id="CardMedReconcileUX-FormGroup-220"
              inline={true}
              style={{padding: "0 4rem 0 2rem"}}
              widths={16}>
              <FormField
                id="CardMedReconcileUX-FormField-227"
                inline={true}
                width={7}>
                <div
                  id="CardMedReconcileUX-div-245"
                  style={{width: "170px"}}>
                  {props.languageUX === "en" ? "physician" : "แพทย์"}
                </div>
                <div
                  id="CardMedReconcileUX-div-246"
                  style={{  borderRadius: "3px",padding: "5px 5px 5px 10px", backgroundColor: "#eeeeee",width: "100%", minHeight: "34px"}}>
                  {props.doctor}
                </div>
              </FormField>
              <FormField
                id="CardMedReconcileUX-FormField-228"
                inline={true}
                width={9}>
                <div
                  id="CardMedReconcileUX-div-247"
                  style={{padding: "0 0.75rem 0 2rem"}}>
                  {props.languageUX === "en" ? "note" : "หมายเหตุ"}
                </div>
                <div
                  id="CardMedReconcileUX-div-248"
                  style={{  borderRadius: "3px",padding: "5px 5px 5px 10px", backgroundColor: "#eeeeee",width: "100%", minHeight: "34px"}}>
                  {props.doctorRemark}
                </div>
              </FormField>
            </FormGroup>
            <FormGroup
              id="CardMedReconcileUX-FormGroup-221"
              inline={true}
              style={{padding: "0 4rem 0 2rem"}}
              widths={16}>
              <FormField
                id="CardMedReconcileUX-FormField-229"
                inline={true}
                width={7}>
                <div
                  id="CardMedReconcileUX-div-249"
                  style={{width: "170px"}}>
                  {props.languageUX === "en" ? "pharmacist" : "เภสัชกร"}
                </div>
                <div
                  id="CardMedReconcileUX-div-250"
                  style={{  borderRadius: "3px",padding: "5px 5px 5px 10px", backgroundColor: "#eeeeee",width: "100%", minHeight: "34px"}}>
                  {props.pharmacist}
                </div>
              </FormField>
              <FormField
                id="CardMedReconcileUX-FormField-230"
                inline={true}
                width={9}>
                <div
                  id="CardMedReconcileUX-div-251"
                  style={{padding: "0 0.75rem 0 2rem"}}>
                  {props.languageUX === "en" ? "note" : "หมายเหตุ"}
                </div>
                <div
                  id="CardMedReconcileUX-div-252"
                  style={{  borderRadius: "3px",padding: "5px 5px 5px 10px", backgroundColor: "#eeeeee",width: "100%", minHeight: "34px"}}>
                  {props.pharmacistRemark}
                </div>
              </FormField>
            </FormGroup>
            <FormGroup
              id="CardMedReconcileUX-FormGroup-222"
              inline={true}
              style={{padding: "0 4rem 0 2rem"}}
              widths={16}>
              <FormField
                id="CardMedReconcileUX-FormField-231"
                inline={true}
                width={7}>
                <div
                  id="CardMedReconcileUX-div-253"
                  style={{width: "170px"}}>
                  {props.languageUX === "en" ? "OPD Nurse" : "พยาบาล OPD"}
                </div>
                <div
                  id="CardMedReconcileUX-div-254"
                  style={{  borderRadius: "3px",padding: "5px 5px 5px 10px", backgroundColor: "#eeeeee",width: "100%", minHeight: "34px"}}>
                  {props.nurseOPD}
                </div>
              </FormField>
              <FormField
                id="CardMedReconcileUX-FormField-232"
                inline={true}
                width={9}>
                <div
                  id="CardMedReconcileUX-div-255"
                  style={{padding: "0 0.75rem 0 2rem"}}>
                  {props.languageUX === "en" ? "note" : "หมายเหตุ"}
                </div>
                <div
                  id="CardMedReconcileUX-div-256"
                  style={{  borderRadius: "3px",padding: "5px 5px 5px 10px", backgroundColor: "#eeeeee",width: "100%", minHeight: "34px"}}>
                  {props.nurseOPDRemark}
                </div>
              </FormField>
            </FormGroup>
            <FormGroup
              id="CardMedReconcileUX-FormGroup-223"
              inline={true}
              style={{padding: "0 4rem 0 2rem"}}
              widths={16}>
              <FormField
                id="CardMedReconcileUX-FormField-233"
                inline={true}
                width={7}>
                <div
                  id="CardMedReconcileUX-div-257"
                  style={{width: "170px"}}>
                  {props.languageUX === "en" ? "IPD Nurse" : "พยาบาล IPD"}
                </div>
                <div
                  id="CardMedReconcileUX-div-258"
                  style={{  borderRadius: "3px",padding: "5px 5px 5px 10px", backgroundColor: "#eeeeee",width: "100%", minHeight: "34px"}}>
                  {props.nurseIPD}
                </div>
              </FormField>
              <FormField
                id="CardMedReconcileUX-FormField-234"
                inline={true}
                width={9}>
                <div
                  id="CardMedReconcileUX-div-259"
                  style={{padding: "0 0.75rem 0 2rem"}}>
                  {props.languageUX === "en" ? "note" : "หมายเหตุ"}
                </div>
                <div
                  id="CardMedReconcileUX-div-260"
                  style={{  borderRadius: "3px",padding: "5px 5px 5px 10px", backgroundColor: "#eeeeee",width: "100%", minHeight: "34px"}}>
                  {props.nurseIPDRemark}
                </div>
              </FormField>
            </FormGroup>
            <FormGroup
              id="CardMedReconcileUX-FormGroup-224"
              inline={true}
              style={{padding: "0 4rem 0 2rem"}}
              widths={16}>
              <FormField
                id="CardMedReconcileUX-FormField-235"
                inline={true}
                width={7}>
                <div
                  id="CardMedReconcileUX-div-261"
                  style={{width: "170px"}}>
                  {props.languageUX === "en" ? "Latest recorder" : "ผู้บันทึกข้อมูลล่าสุด"}
                </div>
                <div
                  id="CardMedReconcileUX-div-262"
                  style={{  borderRadius: "3px",padding: "5px 5px 5px 10px", backgroundColor: "#eeeeee",width: "100%", minHeight: "34px"}}>
                  {props.editUser}
                </div>
              </FormField>
              <FormField
                id="CardMedReconcileUX-FormField-236"
                inline={true}
                width={9}>
                <div
                  id="CardMedReconcileUX-div-263"
                  style={{padding: "0 0.75rem 0 50px", minWidth: "max-content"}}>
                  {props.languageUX === "en" ? "Last recorded date" : "วันเวลาที่บันทึกล่าสุด"}
                </div>
                <div
                  id="CardMedReconcileUX-div-264"
                  style={{  borderRadius: "3px",padding: "5px 5px 5px 10px", backgroundColor: "#eeeeee", minHeight: "34px", width: "175px", minWidth: "max-content"}}>
                  {props.editDate}
                </div>
                <div
                  id="CardMedReconcileUX-div-296">
                  {props.buttonLog}
                </div>
                <div
                  id="CardMedReconcileUX-div-297">
                  {props.buttonPrintMedReconcile}
                </div>
              </FormField>
            </FormGroup>
            <FormGroup
              id="CardMedReconcileUX-FormGroup-225"
              inline={true}
              style={{padding: "0 4rem 0 2rem"}}
              widths={16}>
              <FormField
                id="CardMedReconcileUX-FormField-237"
                inline={true}
                style={{marginRight: "4rem"}}
                width={5}>
                <div
                  id="CardMedReconcileUX-div-265"
                  style={{width: "calc(170px - -1rem)"}}>
                  {props.languageUX === "en" ? "note" : "หมายเหตุ"}
                </div>
                <Input
                  fluid={true}
                  id="CardMedReconcileUX-Input-268"
                  name="remark"
                  onChange={props.changeRemark}
                  value={props.remark}>
                </Input>
              </FormField>
              <FormField
                id="CardMedReconcileUX-FormField-238"
                inline={true}
                width={4}>
                <div
                  id="CardMedReconcileUX-div-266">
                  {props.languageUX === "en" ? "Username" : "ชื่อผู้ใช้"}
                </div>
                <Input
                  fluid={true}
                  id="CardMedReconcileUX-Input-269"
                  name="username"
                  onChange={props.changeUsername}
                  onKeyDown={props.keyDownInput}
                  value={props.username}>
                </Input>
              </FormField>
              <FormField
                id="CardMedReconcileUX-FormField-239"
                inline={true}
                width={4}>
                <div
                  id="CardMedReconcileUX-div-267">
                  {props.languageUX === "en" ? "Password" : "รหัสผ่าน"}
                </div>
                <Input
                  fluid={true}
                  id="CardMedReconcileUX-Input-270"
                  name="password"
                  onChange={props.changePassword}
                  onKeyDown={props.keyDownInput}
                  type="password"
                  value={props.password}>
                </Input>
              </FormField>
            </FormGroup>
            <FormGroup
              id="CardMedReconcileUX-FormGroup-226"
              inline={true}
              style={{marginTop: "3rem"}}
              widths={16}>
              <FormField
                id="CardMedReconcileUX-FormField-240"
                style={{flex:1}}>
              </FormField>
              <FormField
                id="CardMedReconcileUX-FormField-241">
                <Button
                  color="yellow"
                  id="CardMedReconcileUX-Button-275"
                  onClick={props.onSaveDraft}
                  style={{...(props.hideSaveDraft && {display: "none"})}}
                  type="button">
                  {props.languageUX === "en" ? "SAVE DRAFT" : "บันทึกฉบับร่าง"}
                </Button>
              </FormField>
              <FormField
                id="CardMedReconcileUX-FormField-242">
                <Button
                  color="green"
                  disabled={props.disabledSaveBtn}
                  id="CardMedReconcileUX-Button-274"
                  onClick={props.onSaveMedReconcile}
                  type="button">
                  {props.languageUX === "en" ? "SAVE & ACKNOWLEDGE" : "บันทึกและรับทราบ"}
                </Button>
              </FormField>
              <FormField
                id="CardMedReconcileUX-FormField-243">
                <Button
                  color="blue"
                  disabled={props.disabledOrderButton}
                  id="CardMedReconcileUX-Button-273"
                  onClick={props.onOrder}
                  style={{...(!!props.hideAckOrderBtn && {display: "none"})}}
                  type="button">
                  {props.languageUX === "en" ? "ACKNOWLEDGE & ORDER" : "รับทราบและสั่งซื้อ"}
                </Button>
              </FormField>
            </FormGroup>
          </Form>
        </div>
      </div>
    )
}


export default CardMedReconcileUX

export const screenPropsDefault = {"external":true}

/* Date Time : Wed Oct 01 2025 13:02:17 GMT+0700 (Indochina Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardMedReconcileUX-div-0"
        },
        "style": {
          "type": "code",
          "value": "{padding: \"5px\"}"
        }
      },
      "seq": 0
    },
    {
      "from": null,
      "id": 1,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardMedReconcileUX-div-1"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", justifyContent: \"space-between\"}"
        }
      },
      "seq": 1,
      "void": false
    },
    {
      "from": null,
      "id": 2,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardMedReconcileUX-div-2"
        },
        "style": {
          "type": "code",
          "value": "{display: \"none\"}"
        }
      },
      "seq": 3,
      "void": false
    },
    {
      "from": null,
      "id": 3,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardMedReconcileUX-div-3"
        },
        "style": {
          "type": "code",
          "value": "{display: \"none\"}"
        }
      },
      "seq": 4,
      "void": false
    },
    {
      "from": null,
      "id": 4,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardMedReconcileUX-div-4"
        },
        "style": {
          "type": "code",
          "value": "{...(props.medReconcileType === \"TRANSFER\" && {display: \"none\"}), marginTop: \"10px\", borderBottom: \"solid #cccccc 1px\"}"
        }
      },
      "seq": 5,
      "void": false
    },
    {
      "from": null,
      "id": 5,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardMedReconcileUX-div-5"
        },
        "style": {
          "type": "code",
          "value": "{...(props.medReconcileType === \"TRANSFER\" && {display: \"none\"})}"
        }
      },
      "seq": 6,
      "void": false
    },
    {
      "from": null,
      "id": 6,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardMedReconcileUX-div-6"
        },
        "style": {
          "type": "code",
          "value": "{ borderTop: \"solid #cccccc 1px\", marginBottom: \"4rem\", paddingTop: \"1rem\"}"
        }
      },
      "seq": 176,
      "void": false
    },
    {
      "from": null,
      "id": 7,
      "name": "div",
      "parent": 2,
      "props": {
        "children": {
          "type": "value",
          "value": "จากประวัติการสั่งยาจากโรงพยาบาล",
          "valueEN": "From the history of drug orders from the hospital"
        },
        "id": {
          "type": "value",
          "value": "CardMedReconcileUX-div-7"
        },
        "style": {
          "type": "code",
          "value": "{marginTop: \"10px\"}"
        }
      },
      "seq": 7,
      "void": false
    },
    {
      "from": "react-lib/frameworks/Table",
      "id": 8,
      "name": "Table",
      "parent": 2,
      "props": {
        "data": {
          "type": "code",
          "value": "props.internalItems"
        },
        "headers": {
          "type": "value",
          "value": "รหัสยา,ชื่อยาและความแรง,วิธีใช้,QTY,Start Date,Time,Last Date,Time,Note,Off Hold Cont.,"
        },
        "id": {
          "type": "value",
          "value": "CardMedReconcileUX-Table-8"
        },
        "keys": {
          "type": "value",
          "value": "code,name,label,quantity,start_date,start_time,last_dose_date,last_dose_time,note,_action,remove"
        },
        "minRows": {
          "type": "value",
          "value": "6"
        },
        "showPagination": {
          "type": "code",
          "value": "false"
        },
        "style": {
          "type": "code",
          "value": "{height: \"150px\"}"
        }
      },
      "seq": 8,
      "void": false
    },
    {
      "from": null,
      "id": 9,
      "name": "div",
      "parent": 3,
      "props": {
        "children": {
          "type": "value",
          "value": "ประวัติการใช้ยานอกโรงพยาบาล",
          "valueEN": "History of drug use outside hospital"
        },
        "id": {
          "type": "value",
          "value": "CardMedReconcileUX-div-9"
        },
        "style": {
          "type": "code",
          "value": "{marginTop: \"10px\"}"
        }
      },
      "seq": 9,
      "void": false
    },
    {
      "from": null,
      "id": 11,
      "name": "div",
      "parent": 5,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardMedReconcileUX-div-11"
        },
        "style": {
          "type": "code",
          "value": "{display: !props.external && props.medReconcileType !== \"DISCHARGE\" ?  \"block\" : \"none\", height: \"350px\"}"
        }
      },
      "seq": 11,
      "void": false
    },
    {
      "from": null,
      "id": 12,
      "name": "div",
      "parent": 5,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardMedReconcileUX-div-12"
        },
        "style": {
          "type": "code",
          "value": "{display: props.external ? \"block\" : \"none\", height: \"300px\"}"
        }
      },
      "seq": 165,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 13,
      "name": "Button",
      "parent": 4,
      "props": {
        "children": {
          "type": "code",
          "value": "props.medReconcileType === \"DISCHARGE\" ? \"เลือกรายการยาจาก Medication Reconciliation แรกรับ\":\" เพิ่มจากประวัติการสั่งยาจากโรงพยาบาล\""
        },
        "color": {
          "type": "code",
          "value": "props.external ? null : \"blue\""
        },
        "id": {
          "type": "value",
          "value": "CardMedReconcileUX-Button-13"
        },
        "onClick": {
          "type": "code",
          "value": "props.setInternal"
        },
        "size": {
          "type": "value",
          "value": "small"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 13,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 14,
      "name": "Button",
      "parent": 4,
      "props": {
        "children": {
          "type": "code",
          "value": "props.externalNameBtn"
        },
        "color": {
          "type": "code",
          "value": "props.external ? \"blue\" :  null"
        },
        "id": {
          "type": "value",
          "value": "CardMedReconcileUX-Button-14"
        },
        "onClick": {
          "type": "code",
          "value": "props.setExternal"
        },
        "size": {
          "type": "value",
          "value": "small"
        }
      },
      "seq": 14,
      "void": false
    },
    {
      "from": "react-lib/frameworks/Table",
      "id": 15,
      "name": "Table",
      "parent": 3,
      "props": {
        "data": {
          "type": "code",
          "value": "props.externalItems"
        },
        "getTrProps": {
          "type": "code",
          "value": "props.externalRowProps"
        },
        "headers": {
          "type": "value",
          "value": "ประเภท,ชื่อ,QTY,Start Date,Time,Last Date,Time,Note,Off Hold Cont.,"
        },
        "id": {
          "type": "value",
          "value": "CardMedReconcileUX-Table-15"
        },
        "keys": {
          "type": "value",
          "value": "typeName,name,quantity,start_date,start_time,last_dose_date,last_dose_time,note,_action,remove"
        },
        "minRows": {
          "type": "value",
          "value": "6"
        },
        "showPagination": {
          "type": "code",
          "value": "false"
        },
        "style": {
          "type": "code",
          "value": "{height: \"150px\"}"
        }
      },
      "seq": 15,
      "void": false
    },
    {
      "from": null,
      "id": 18,
      "label": "divgrid",
      "name": "div",
      "parent": 12,
      "props": {
        "id": {
          "type": "value",
          "value": "CardMedReconcileUX-div-18"
        },
        "style": {
          "type": "code",
          "value": "{\"width\":\"100%\",\"height\":\"100%\",\"display\":\"grid\",\"position\":\"relative\",\"gridTemplateRows\":\"repeat(14, 1fr)\",\"gridTemplateColumns\":\"repeat(50, 1fr)\"}"
        }
      },
      "seq": 18,
      "void": false
    },
    {
      "from": null,
      "id": 56,
      "name": "div",
      "parent": 18,
      "props": {
        "children": {
          "type": "value",
          "value": "ประเภท",
          "valueEN": "type"
        },
        "id": {
          "type": "value",
          "value": "CardMedReconcileUX-div-56"
        },
        "style": {
          "type": "code",
          "value": "{gridRow: \"2/3\", gridColumn: \"3/6\", }"
        }
      },
      "seq": 56,
      "void": false
    },
    {
      "from": null,
      "id": 57,
      "name": "div",
      "parent": 18,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardMedReconcileUX-div-57"
        },
        "style": {
          "type": "code",
          "value": "{ gridRow: \"10/11\", gridColumn: \"3/50\",}"
        }
      },
      "seq": 57,
      "void": false
    },
    {
      "from": null,
      "id": 59,
      "name": "div",
      "parent": 18,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardMedReconcileUX-div-59"
        },
        "style": {
          "type": "code",
          "value": "{ padding: \"5px\", textAlign: \"right\", gridRow: \"11/13\", gridColumn: \"2/6\", }"
        }
      },
      "seq": 59,
      "void": false
    },
    {
      "from": null,
      "id": 60,
      "name": "div",
      "parent": 18,
      "props": {
        "id": {
          "type": "value",
          "value": "CardMedReconcileUX-div-60"
        },
        "style": {
          "type": "code",
          "value": "{ gridRow: \"3/5\", gridColumn: \"3/13\", }"
        }
      },
      "seq": 60,
      "void": false
    },
    {
      "from": null,
      "id": 67,
      "name": "div",
      "parent": 18,
      "props": {
        "id": {
          "type": "value",
          "value": "CardMedReconcileUX-div-67"
        },
        "style": {
          "type": "code",
          "value": "{ gridRow: \"12/14\", gridColumn: \"3/14\", }"
        }
      },
      "seq": 67,
      "void": false
    },
    {
      "from": null,
      "id": 68,
      "name": "div",
      "parent": 18,
      "props": {
        "id": {
          "type": "value",
          "value": "CardMedReconcileUX-div-68"
        },
        "style": {
          "type": "code",
          "value": "{ gridRow: \"12/14\", gridColumn: \"31/41\", justifyContent:\"flex-end\", display: \"flex\"}"
        }
      },
      "seq": 68,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 70,
      "name": "Button",
      "parent": 68,
      "props": {
        "children": {
          "type": "value",
          "value": "เพิ่ม/อัพเดทรายการนี้",
          "valueEN": "Add/Update this item"
        },
        "color": {
          "type": "value",
          "value": "green"
        },
        "disabled": {
          "type": "code",
          "value": "props.disabledAddUpdateBtn"
        },
        "id": {
          "type": "value",
          "value": "CardMedReconcileUX-Button-70"
        },
        "onClick": {
          "type": "code",
          "value": "props.addOtherDrug"
        },
        "size": {
          "type": "value",
          "value": "small"
        },
        "style": {
          "type": "code",
          "value": "{width: \"fit-content\", height: \"100%\"}"
        }
      },
      "seq": 70,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 73,
      "name": "Dropdown",
      "parent": 60,
      "props": {
        "disabled": {
          "type": "code",
          "value": "props.disableDrugType"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardMedReconcileUX-Dropdown-73"
        },
        "onChange": {
          "type": "code",
          "value": "props.changeExternalType"
        },
        "options": {
          "type": "code",
          "value": "props.externalTypeOptions"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.externalType"
        }
      },
      "seq": 73,
      "void": false
    },
    {
      "from": null,
      "id": 78,
      "name": "div",
      "parent": 18,
      "props": {
        "children": {
          "type": "value",
          "value": "ชื่อ/รายละเอียด",
          "valueEN": "Name/Details"
        },
        "id": {
          "type": "value",
          "value": "CardMedReconcileUX-div-78"
        },
        "style": {
          "type": "code",
          "value": "{ gridRow: \"2/3\", gridColumn: \"14/20\", }"
        }
      },
      "seq": 78,
      "void": false
    },
    {
      "from": null,
      "id": 79,
      "name": "div",
      "parent": 18,
      "props": {
        "children": {
          "type": "code",
          "value": "props.externalDrug"
        },
        "id": {
          "type": "value",
          "value": "CardMedReconcileUX-div-79"
        },
        "style": {
          "type": "code",
          "value": "{ gridRow: \"3/5\", gridColumn: \"14/28\", }"
        }
      },
      "seq": 79,
      "void": false
    },
    {
      "from": null,
      "id": 80,
      "name": "div",
      "parent": 18,
      "props": {
        "children": {
          "type": "value",
          "value": "จำนวน",
          "valueEN": "Qty"
        },
        "id": {
          "type": "value",
          "value": "CardMedReconcileUX-div-80"
        },
        "style": {
          "type": "code",
          "value": "{gridRow: \"2/3\", gridColumn: \"29/32\", }"
        }
      },
      "seq": 80,
      "void": false
    },
    {
      "from": null,
      "id": 81,
      "name": "div",
      "parent": 18,
      "props": {
        "id": {
          "type": "value",
          "value": "CardMedReconcileUX-div-81"
        },
        "style": {
          "type": "code",
          "value": "{ gridRow: \"3/5\", gridColumn: \"29/36\",}"
        }
      },
      "seq": 81,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 82,
      "name": "Input",
      "parent": 81,
      "props": {
        "disabled": {
          "type": "code",
          "value": "props.disabledQty"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardMedReconcileUX-Input-82"
        },
        "min": {
          "type": "code",
          "value": "0"
        },
        "onChange": {
          "type": "code",
          "value": "props.changeQty"
        },
        "style": {
          "type": "code",
          "value": "{height: \"100%\"}"
        },
        "type": {
          "type": "value",
          "value": "number"
        },
        "value": {
          "type": "code",
          "value": "props.qty"
        }
      },
      "seq": 82,
      "void": false
    },
    {
      "from": null,
      "id": 83,
      "name": "div",
      "parent": 18,
      "props": {
        "id": {
          "type": "value",
          "value": "CardMedReconcileUX-div-83"
        },
        "style": {
          "type": "code",
          "value": "{ gridRow: \"12/14\", gridColumn: \"42/48\", border: \"solid 1px rgb(200, 200, 200, 0.5)\" }"
        }
      },
      "seq": 83,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 84,
      "name": "Button",
      "parent": 83,
      "props": {
        "children": {
          "type": "value",
          "value": "เคลียร์",
          "valueEN": "clear"
        },
        "color": {
          "type": "value",
          "value": "orange"
        },
        "id": {
          "type": "value",
          "value": "CardMedReconcileUX-Button-84"
        },
        "onClick": {
          "type": "code",
          "value": "props.clearExternalDrug"
        },
        "size": {
          "type": "value",
          "value": "small"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\", height: \"100%\"}"
        }
      },
      "seq": 84,
      "void": false
    },
    {
      "from": null,
      "id": 85,
      "name": "div",
      "parent": 18,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardMedReconcileUX-div-85"
        },
        "style": {
          "type": "code",
          "value": "{ gridRow: \"6/7\", gridColumn: \"3/6\"}"
        }
      },
      "seq": 85,
      "void": false
    },
    {
      "from": null,
      "id": 86,
      "name": "div",
      "parent": 18,
      "props": {
        "id": {
          "type": "value",
          "value": "CardMedReconcileUX-div-86"
        },
        "style": {
          "type": "code",
          "value": "{ gridRow: \"7/9\", gridColumn: \"3/9\"}"
        }
      },
      "seq": 86,
      "void": false
    },
    {
      "from": null,
      "id": 87,
      "name": "div",
      "parent": 18,
      "props": {
        "children": {
          "type": "value",
          "value": "หน่วย",
          "valueEN": "Unit"
        },
        "id": {
          "type": "value",
          "value": "CardMedReconcileUX-div-87"
        },
        "style": {
          "type": "code",
          "value": "{ gridRow: \"6/7\", gridColumn: \"10/12\"}"
        }
      },
      "seq": 87,
      "void": false
    },
    {
      "from": null,
      "id": 88,
      "name": "div",
      "parent": 18,
      "props": {
        "id": {
          "type": "value",
          "value": "CardMedReconcileUX-div-88"
        },
        "style": {
          "type": "code",
          "value": "{ gridRow: \"7/9\", gridColumn: \"10/17\"}"
        }
      },
      "seq": 88,
      "void": false
    },
    {
      "from": null,
      "id": 89,
      "name": "div",
      "parent": 18,
      "props": {
        "children": {
          "type": "value",
          "value": "ช่องทาง",
          "valueEN": "Route"
        },
        "id": {
          "type": "value",
          "value": "CardMedReconcileUX-div-89"
        },
        "style": {
          "type": "code",
          "value": "{ gridRow: \"6/7\", gridColumn: \"18/20\"}"
        }
      },
      "seq": 89,
      "void": false
    },
    {
      "from": null,
      "id": 90,
      "name": "div",
      "parent": 18,
      "props": {
        "id": {
          "type": "value",
          "value": "CardMedReconcileUX-div-90"
        },
        "style": {
          "type": "code",
          "value": "{ gridRow: \"7/9\", gridColumn: \"18/25\"}"
        }
      },
      "seq": 90,
      "void": false
    },
    {
      "from": null,
      "id": 91,
      "name": "div",
      "parent": 18,
      "props": {
        "children": {
          "type": "value",
          "value": "ตำแหน่ง",
          "valueEN": "Site"
        },
        "id": {
          "type": "value",
          "value": "CardMedReconcileUX-div-91"
        },
        "style": {
          "type": "code",
          "value": "{ gridRow: \"6/7\", gridColumn: \"26/28\"}"
        }
      },
      "seq": 91,
      "void": false
    },
    {
      "from": null,
      "id": 92,
      "name": "div",
      "parent": 18,
      "props": {
        "id": {
          "type": "value",
          "value": "CardMedReconcileUX-div-92"
        },
        "style": {
          "type": "code",
          "value": "{ gridRow: \"7/9\", gridColumn: \"26/33\"}"
        }
      },
      "seq": 92,
      "void": false
    },
    {
      "from": null,
      "id": 93,
      "name": "div",
      "parent": 18,
      "props": {
        "children": {
          "type": "value",
          "value": "ความถี่",
          "valueEN": "Frequency"
        },
        "id": {
          "type": "value",
          "value": "CardMedReconcileUX-div-93"
        },
        "style": {
          "type": "code",
          "value": "{ gridRow: \"6/7\", gridColumn: \"34/37\",}"
        }
      },
      "seq": 93,
      "void": false
    },
    {
      "from": null,
      "id": 94,
      "name": "div",
      "parent": 18,
      "props": {
        "id": {
          "type": "value",
          "value": "CardMedReconcileUX-div-94"
        },
        "style": {
          "type": "code",
          "value": "{ gridRow: \"7/9\", gridColumn: \"34/42\"}"
        }
      },
      "seq": 94,
      "void": false
    },
    {
      "from": null,
      "id": 95,
      "name": "div",
      "parent": 18,
      "props": {
        "children": {
          "type": "value",
          "value": "วิธี",
          "valueEN": "Method"
        },
        "id": {
          "type": "value",
          "value": "CardMedReconcileUX-div-95"
        },
        "style": {
          "type": "code",
          "value": "{ gridRow: \"6/7\", gridColumn: \"43/45\"}"
        }
      },
      "seq": 95,
      "void": false
    },
    {
      "from": null,
      "id": 96,
      "name": "div",
      "parent": 18,
      "props": {
        "id": {
          "type": "value",
          "value": "CardMedReconcileUX-div-96"
        },
        "style": {
          "type": "code",
          "value": "{ gridRow: \"7/9\", gridColumn: \"43/50\"}"
        }
      },
      "seq": 96,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 97,
      "name": "Input",
      "parent": 86,
      "props": {
        "disabled": {
          "type": "code",
          "value": "props.disabledDrugQty"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardMedReconcileUX-Input-97"
        },
        "min": {
          "type": "code",
          "value": "0"
        },
        "onChange": {
          "type": "code",
          "value": "props.changeDose"
        },
        "style": {
          "type": "code",
          "value": ""
        },
        "type": {
          "type": "value",
          "value": "number"
        },
        "value": {
          "type": "code",
          "value": "props.dose"
        }
      },
      "seq": 97,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 98,
      "name": "Dropdown",
      "parent": 88,
      "props": {
        "disabled": {
          "type": "code",
          "value": "props.disabledUnit"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardMedReconcileUX-Dropdown-98"
        },
        "onChange": {
          "type": "code",
          "value": "props.changeUnit"
        },
        "options": {
          "type": "code",
          "value": "props.unitOptions"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{height: \"auto\"}"
        },
        "value": {
          "type": "code",
          "value": "props.unit"
        }
      },
      "seq": 98,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 99,
      "name": "Dropdown",
      "parent": 90,
      "props": {
        "disabled": {
          "type": "code",
          "value": "props.disabledRoute"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardMedReconcileUX-Dropdown-99"
        },
        "onChange": {
          "type": "code",
          "value": "props.changeRoute"
        },
        "options": {
          "type": "code",
          "value": "props.routeOptions"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.route"
        }
      },
      "seq": 99,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 100,
      "name": "Dropdown",
      "parent": 92,
      "props": {
        "disabled": {
          "type": "code",
          "value": "props.disabledSite"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardMedReconcileUX-Dropdown-100"
        },
        "onChange": {
          "type": "code",
          "value": "props.changeSite"
        },
        "options": {
          "type": "code",
          "value": "props.siteOptions"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.site"
        }
      },
      "seq": 100,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 101,
      "name": "Dropdown",
      "parent": 94,
      "props": {
        "disabled": {
          "type": "code",
          "value": "props.disableFrequency"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardMedReconcileUX-Dropdown-101"
        },
        "onChange": {
          "type": "code",
          "value": "props.changeFrequency"
        },
        "options": {
          "type": "code",
          "value": "props.frequencyOptions"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.frequency"
        }
      },
      "seq": 101,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 102,
      "name": "Dropdown",
      "parent": 96,
      "props": {
        "disabled": {
          "type": "code",
          "value": "props.disabledMethod"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardMedReconcileUX-Dropdown-102"
        },
        "onChange": {
          "type": "code",
          "value": "props.changeMethod"
        },
        "options": {
          "type": "code",
          "value": "props.methodOptions"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.method"
        }
      },
      "seq": 102,
      "void": false
    },
    {
      "from": null,
      "id": 103,
      "name": "div",
      "parent": 18,
      "props": {
        "children": {
          "type": "value",
          "value": "บันทึก",
          "valueEN": "Note"
        },
        "id": {
          "type": "value",
          "value": "CardMedReconcileUX-div-103"
        },
        "style": {
          "type": "code",
          "value": "{ gridRow: \"2/3\", gridColumn: \"37/40\"}"
        }
      },
      "seq": 103,
      "void": false
    },
    {
      "from": null,
      "id": 104,
      "name": "div",
      "parent": 18,
      "props": {
        "id": {
          "type": "value",
          "value": "CardMedReconcileUX-div-104"
        },
        "style": {
          "type": "code",
          "value": "{ gridRow: \"3/5\", gridColumn: \"37/50\"}"
        }
      },
      "seq": 104,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 105,
      "name": "Input",
      "parent": 104,
      "props": {
        "disabled": {
          "type": "code",
          "value": "props.disabledNote"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardMedReconcileUX-Input-105"
        },
        "onChange": {
          "type": "code",
          "value": "props.changeNote"
        },
        "style": {
          "type": "code",
          "value": "{height: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.note"
        }
      },
      "seq": 105,
      "void": false
    },
    {
      "from": null,
      "id": 118,
      "name": "div",
      "parent": 18,
      "props": {
        "id": {
          "type": "value",
          "value": "CardMedReconcileUX-div-118"
        },
        "style": {
          "type": "code",
          "value": "{ gridRow: \"12/14\", gridColumn: \"12/20\", display:  props.checkedUnknowLastDose? \"block\": \"none\"}"
        }
      },
      "seq": 118,
      "void": false
    },
    {
      "from": null,
      "id": 119,
      "name": "div",
      "parent": 18,
      "props": {
        "id": {
          "type": "value",
          "value": "CardMedReconcileUX-div-119"
        },
        "style": {
          "type": "code",
          "value": "{ gridRow: \"12/14\", gridColumn: \"21/33\", display:  props.reason === \"etc\"? \"block\": \"none\"}"
        }
      },
      "seq": 119,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 120,
      "name": "Dropdown",
      "parent": 118,
      "props": {
        "id": {
          "type": "value",
          "value": "CardMedReconcileUX-Dropdown-120"
        },
        "onChange": {
          "type": "code",
          "value": "props.changeReason"
        },
        "options": {
          "type": "code",
          "value": "props.reasonOptions"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.reason"
        }
      },
      "seq": 120,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 121,
      "name": "Input",
      "parent": 119,
      "props": {
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardMedReconcileUX-Input-121"
        },
        "onChange": {
          "type": "code",
          "value": "props.changeOtherReason"
        },
        "style": {
          "type": "code",
          "value": "{height: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.otherReason"
        }
      },
      "seq": 121,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 122,
      "name": "Checkbox",
      "parent": 67,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.checkedUnknowLastDose"
        },
        "disabled": {
          "type": "code",
          "value": "props.disabledUnknowLastDose"
        },
        "id": {
          "type": "value",
          "value": "CardMedReconcileUX-Checkbox-122"
        },
        "label": {
          "type": "value",
          "value": "ไม่สามารถระบุ Last dose",
          "valueEN": "Last dose cannot be specified"
        },
        "onChange": {
          "type": "code",
          "value": "props.changeUnknowLastDose"
        },
        "style": {
          "type": "code",
          "value": "{padding: \"5px\", marginTop:\"0.25rem\"}"
        }
      },
      "seq": 122,
      "void": false
    },
    {
      "from": null,
      "id": 134,
      "name": "div",
      "parent": 1,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardMedReconcileUX-div-134"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\",  paddingTop: \"10px\", textAlign: \"right\"}"
        }
      },
      "seq": 135,
      "void": false
    },
    {
      "from": null,
      "id": 135,
      "name": "div",
      "parent": 1,
      "props": {
        "children": {
          "type": "value",
          "value": "การตรวจสอบการใช้ยา",
          "valueEN": "Medication Reconcilliation"
        },
        "id": {
          "type": "value",
          "value": "CardMedReconcileUX-div-135"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\", fontSize: \"1.3rem\", padding: \"5px\"}"
        }
      },
      "seq": 134,
      "void": false
    },
    {
      "from": null,
      "id": 136,
      "name": "div",
      "parent": 134,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardMedReconcileUX-div-136"
        }
      },
      "seq": 136,
      "void": false
    },
    {
      "from": null,
      "id": 137,
      "name": "div",
      "parent": 134,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardMedReconcileUX-div-137"
        }
      },
      "seq": 137,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 138,
      "name": "Button",
      "parent": 136,
      "props": {
        "children": {
          "type": "value",
          "value": "เลือก Medication Reconciliation",
          "valueEN": "เลือกใบ Medication Reconciliation"
        },
        "id": {
          "type": "value",
          "value": "CardMedReconcileUX-Button-138"
        },
        "onClick": {
          "type": "code",
          "value": "props.onShowMedReconcileList"
        }
      },
      "seq": 138,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 139,
      "name": "Dropdown",
      "parent": 137,
      "props": {
        "disabled": {
          "type": "code",
          "value": "!!props.disabledMedReconcileType"
        },
        "fluid": {
          "type": "code",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardMedReconcileUX-Dropdown-139"
        },
        "onChange": {
          "type": "code",
          "value": "props.changeMedReconcileType"
        },
        "options": {
          "type": "code",
          "value": "props.medReconcileTypeOptions"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{transform: \"scale(0.85)\"}"
        },
        "value": {
          "type": "code",
          "value": "props.medReconcileType"
        }
      },
      "seq": 139,
      "void": false
    },
    {
      "from": null,
      "id": 141,
      "name": "div",
      "parent": 136,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardMedReconcileUX-div-141"
        },
        "style": {
          "type": "code",
          "value": "{display: props.showMedReconcileList? \"block\": \"none\", position: \"absolute\", zIndex: 100, padding: \"10px\", backgroundColor: \"#FFF\", right:\"10%\"}"
        }
      },
      "seq": 141,
      "void": false
    },
    {
      "from": "react-lib/frameworks/Table",
      "id": 142,
      "name": "Table",
      "parent": 141,
      "props": {
        "data": {
          "type": "code",
          "value": "props.medReconcileList"
        },
        "getTrProps": {
          "type": "code",
          "value": "props.getTrPropsMedReconcileList"
        },
        "headers": {
          "type": "value",
          "value": "Type,Encounter,วันที่และเวลาสร้าง"
        },
        "id": {
          "type": "value",
          "value": "CardMedReconcileUX-Table-142"
        },
        "keys": {
          "type": "value",
          "value": "med_reconciliation_type_label,name,created_datetime"
        },
        "minRows": {
          "type": "value",
          "value": "3"
        },
        "showPagination": {
          "type": "code",
          "value": "false"
        },
        "style": {
          "type": "code",
          "value": "{height: \"250px\", width: \"600px\", textAlign: \"center\"}"
        },
        "widths": {
          "type": "value",
          "value": "150,,200"
        }
      },
      "seq": 142,
      "void": false
    },
    {
      "from": null,
      "id": 143,
      "name": "div",
      "parent": 141,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardMedReconcileUX-div-143"
        },
        "style": {
          "type": "code",
          "value": "{paddingTop: \"5px\", display: \"flex\", justifyContent: props.enableNewButtonInMedReconcileList ? \"space-between\" : \"flex-end\"}"
        }
      },
      "seq": 143,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 144,
      "name": "Button",
      "parent": 143,
      "props": {
        "children": {
          "type": "value",
          "value": "ใหม่",
          "valueEN": "New"
        },
        "className": {
          "type": "value",
          "value": ""
        },
        "color": {
          "type": "value",
          "value": "green"
        },
        "id": {
          "type": "value",
          "value": "CardMedReconcileUX-Button-144"
        },
        "onClick": {
          "type": "code",
          "value": "props.onNewMedReconcile"
        },
        "style": {
          "type": "code",
          "value": "{...(!props.enableNewButtonInMedReconcileList && {display: \"none\"})}"
        }
      },
      "seq": 144,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 145,
      "name": "Button",
      "parent": 143,
      "props": {
        "children": {
          "type": "value",
          "value": "เลือก",
          "valueEN": "choose"
        },
        "color": {
          "type": "value",
          "value": "blue"
        },
        "id": {
          "type": "value",
          "value": "CardMedReconcileUX-Button-145"
        },
        "onClick": {
          "type": "code",
          "value": "props.onMedReconcileSelect"
        }
      },
      "seq": 145,
      "void": false
    },
    {
      "from": null,
      "id": 146,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardMedReconcileUX-div-146"
        },
        "style": {
          "type": "code",
          "value": "{display: props.medReconcileType === \"DISCHARGE\" ||  props.medReconcileType === \"TRANSFER\" ?\"none\":\"flex\", flexDirection: \"column\"}"
        }
      },
      "seq": 2,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 147,
      "name": "Checkbox",
      "parent": 146,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.hasNoPastMed"
        },
        "disabled": {
          "type": "code",
          "value": "props.disabledNoPastMed"
        },
        "id": {
          "type": "value",
          "value": "CardMedReconcileUX-Checkbox-147"
        },
        "label": {
          "type": "value",
          "value": "ไม่มีรายการยาเดิม",
          "valueEN": "No original medication list"
        },
        "onChange": {
          "type": "code",
          "value": "props.changeHasNoPastMed"
        },
        "style": {
          "type": "code",
          "value": "{padding: \"10px\", width: \"fit-content\"}"
        }
      },
      "seq": 147,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 149,
      "name": "Checkbox",
      "parent": 146,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.notAvailableAtAdmit"
        },
        "disabled": {
          "type": "code",
          "value": "props.notAvailableDisabled"
        },
        "id": {
          "type": "value",
          "value": "CardMedReconcileUX-Checkbox-149"
        },
        "label": {
          "type": "code",
          "value": "`Not Available at time of admission will be completed in ${props.configMedReconcileAvailable} hour(s). ${props.limitDateTime}`"
        },
        "onChange": {
          "type": "code",
          "value": "props.changeNotAvailableAtAdmit"
        },
        "style": {
          "type": "code",
          "value": "{padding: \"10px\", width: \"fit-content\"}"
        }
      },
      "seq": 149,
      "void": false
    },
    {
      "from": null,
      "id": 155,
      "name": "label",
      "parent": 85,
      "props": {
        "children": {
          "type": "value",
          "value": "ปริมาณยา",
          "valueEN": "Dose"
        },
        "id": {
          "type": "value",
          "value": "CardMedReconcileUX-label-155"
        }
      },
      "seq": 155,
      "void": false
    },
    {
      "from": null,
      "id": 157,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardMedReconcileUX-div-157"
        },
        "style": {
          "type": "code",
          "value": "{...(props.medReconcileType === \"TRANSFER\" && {display: \"none\"})}"
        }
      },
      "seq": 146,
      "void": false
    },
    {
      "from": "react-lib/frameworks/Table",
      "id": 159,
      "name": "Table",
      "parent": 157,
      "props": {
        "className": {
          "type": "value",
          "value": "--rt-tbody-overflow-y-hidden"
        },
        "data": {
          "type": "code",
          "value": "props.medicationItems"
        },
        "getTrProps": {
          "type": "code",
          "value": "props.medicationRowProps"
        },
        "headers": {
          "type": "code",
          "value": "props.medReconcileType === \"DISCHARGE\"? \"TYPE,รหัสยา, ชื่อยาและความแรง, วิธีใช้, QTY, Start Date, Time, Last Date, Time, Note,ใช้ยาต่อ,หยุดยา,\" : \"TYPE,รหัสยา, ชื่อยาและความแรง, วิธีใช้, QTY, Start Date, Time, Last Date, Time, Note,Off,Hold,Cont.,Edited date / time,\""
        },
        "id": {
          "type": "value",
          "value": "CardMedReconcileUX-Table-159"
        },
        "keys": {
          "type": "code",
          "value": "props.medReconcileType === \"DISCHARGE\"? \"isExternal,code, name, label,quantity, start_date_text, start_time_text, last_date_text, last_time_text, btn_note,_is_cont,_is_stop,delete\" : \"isExternal,code,name,label,quantity, start_date_text, start_time_text, last_date_text, last_time_text, btn_note,_action_off,_action_hold,_action_cont,edit_time,delete\""
        },
        "minRows": {
          "type": "value",
          "value": "6"
        },
        "name": {
          "type": "value",
          "value": ""
        },
        "showPagination": {
          "type": "code",
          "value": "false"
        },
        "style": {
          "type": "code",
          "value": "{height: \"300px\"}"
        },
        "widths": {
          "type": "code",
          "value": "props.medReconcileType === \"DISCHARGE\"? \"120,80,,200,50,100,80,100,80,100,100,100,60\" : \"80,80,200,200,50,100,80,100,80,100,60,60,60,120,60\""
        }
      },
      "seq": 170,
      "void": false
    },
    {
      "from": null,
      "id": 165,
      "name": "div",
      "parent": 5,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardMedReconcileUX-div-165"
        },
        "style": {
          "type": "code",
          "value": "{display: !props.external && props.medReconcileType === \"DISCHARGE\" ?  \"block\" : \"none\", height: \"280px\"}"
        }
      },
      "seq": 12,
      "void": false
    },
    {
      "from": null,
      "id": 166,
      "name": "div",
      "parent": 165,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardMedReconcileUX-div-166"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 166,
      "void": false
    },
    {
      "from": null,
      "id": 167,
      "name": "div",
      "parent": 165,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardMedReconcileUX-div-167"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", justifyContent: \"flex-end\", marginTop: \"10px\"}"
        }
      },
      "seq": 167,
      "void": false
    },
    {
      "from": "react-lib/frameworks/Table",
      "id": 168,
      "name": "Table",
      "parent": 166,
      "props": {
        "data": {
          "type": "code",
          "value": "props.drugIPDAdmit"
        },
        "headers": {
          "type": "value",
          "value": ",รหัสยา, ชื่อยาและความแรง, วิธีใช้, QTY, Start Date, Time, Last Date, Time, Note,Off,Hold,Cont."
        },
        "id": {
          "type": "value",
          "value": "drugIPDAdmit"
        },
        "keys": {
          "type": "value",
          "value": "_add,code,nameDiv,label,quantity, start_date_text, start_time_text, last_date_text, last_time_text, btn_note,_action_off,_action_hold,_action_cont"
        },
        "minRows": {
          "type": "value",
          "value": "5"
        },
        "showPagination": {
          "type": "code",
          "value": "false"
        },
        "style": {
          "type": "code",
          "value": "{height:\"220px\"}"
        },
        "widths": {
          "type": "value",
          "value": "80,80,,200,50,100,80,100,80,100,60,60,60"
        }
      },
      "seq": 168,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 169,
      "name": "Button",
      "parent": 167,
      "props": {
        "children": {
          "type": "value",
          "value": "เพิ่มเข้ารายการปล่อย MR",
          "valueEN": "Add to MR discharge List"
        },
        "color": {
          "type": "value",
          "value": "green"
        },
        "disabled": {
          "type": "code",
          "value": "props.medReconcileIPDAdmitSelectOrder?.length === 0 && props.medReconcileIPDAdmitSelectItem?.length === 0"
        },
        "fluid": {
          "type": "code",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardMedReconcileUX-Button-169"
        },
        "onClick": {
          "type": "code",
          "value": "props.onAddDrugToMRDischarge"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 169,
      "void": false
    },
    {
      "from": null,
      "id": 170,
      "name": "div",
      "parent": 157,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardMedReconcileUX-div-170"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", justifyContent: \"space-between\", alignItems: \"center\"}"
        }
      },
      "seq": 159,
      "void": false
    },
    {
      "from": null,
      "id": 171,
      "name": "div",
      "parent": 170,
      "props": {
        "children": {
          "type": "code",
          "value": "props.medReconcileType === \"DISCHARGE\" ? \"Home Medication\" : `Past Medication ${props.pastMedRecordDate}`"
        },
        "id": {
          "type": "value",
          "value": "CardMedReconcileUX-div-171"
        },
        "style": {
          "type": "code",
          "value": "{margin: \"10px 0px\", fontSize: \"16px\", fontWeight: \"bold\", flex: 1}"
        }
      },
      "seq": 171,
      "void": false
    },
    {
      "from": null,
      "id": 172,
      "name": "div",
      "parent": 170,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardMedReconcileUX-div-172"
        },
        "style": {
          "type": "code",
          "value": "{display: props.medReconcileType === \"DISCHARGE\" ? \"flex\" : \"none\", justifyContent: \"space-evenly\", alignItems: \"center\", flex: \"1\"}"
        }
      },
      "seq": 172,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 173,
      "name": "Checkbox",
      "parent": 172,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.checkedIPDHome"
        },
        "id": {
          "type": "value",
          "value": "CardMedReconcileUX-Checkbox-173"
        },
        "label": {
          "type": "value",
          "value": "IPD Home",
          "valueEN": "IPD Home"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeCheckedIPDHome"
        }
      },
      "seq": 173,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 174,
      "name": "Checkbox",
      "parent": 172,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.checkedMRIPD"
        },
        "id": {
          "type": "value",
          "value": "CardMedReconcileUX-Checkbox-174"
        },
        "label": {
          "type": "value",
          "value": "MR IPD แรกรับ",
          "valueEN": "MR IPD First Admission"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeCheckedMRIPD"
        }
      },
      "seq": 174,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 175,
      "name": "Checkbox",
      "parent": 172,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.checkedSuggestion"
        },
        "id": {
          "type": "value",
          "value": "CardMedReconcileUX-Checkbox-175"
        },
        "label": {
          "type": "value",
          "value": "คำแนะนำ",
          "valueEN": "Suggestion"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeCheckedSuggestion"
        }
      },
      "seq": 175,
      "void": false
    },
    {
      "from": null,
      "id": 176,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardMedReconcileUX-div-176"
        },
        "style": {
          "type": "code",
          "value": "{...(props.medReconcileType !== \"TRANSFER\" && {display: \"none\"})}"
        }
      },
      "seq": 157,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 178,
      "name": "Button",
      "parent": 176,
      "props": {
        "children": {
          "type": "value",
          "value": "Sync รายการยา (ต้องรับทราบทุกครั้ง)",
          "valueEN": "Sync your medication list (must be acknowledged every time)"
        },
        "color": {
          "type": "value",
          "value": "purple"
        },
        "id": {
          "type": "value",
          "value": "CardMedReconcileUX-Button-178"
        },
        "onClick": {
          "type": "code",
          "value": "props.onClickSyncDrugTransfer"
        }
      },
      "seq": 178,
      "void": false
    },
    {
      "from": "react-lib/frameworks/Table",
      "id": 179,
      "name": "Table",
      "parent": 176,
      "props": {
        "data": {
          "type": "code",
          "value": "props.transferOneDayData"
        },
        "getTdProps": {
          "type": "code",
          "value": "props.transferOneDayTdProps"
        },
        "getTrProps": {
          "type": "code",
          "value": "props.transferOneDayTrProps"
        },
        "headers": {
          "type": "value",
          "value": "TYPE,รหัสยา,ชื่อยาและความแรง,วิธีใช้,QTY,Start Date,Time,Last Date,Time,Note,Off,On"
        },
        "id": {
          "type": "value",
          "value": "CardMedReconcileUX-Table-179"
        },
        "keys": {
          "type": "value",
          "value": "type, code, name, label, quantity, startDate, startTime, lastDoseDate, lastDoseTime,noteIcon,off,on"
        },
        "minRows": {
          "type": "value",
          "value": "5"
        },
        "showPagination": {
          "type": "code",
          "value": "false"
        },
        "widths": {
          "type": "value",
          "value": "80,100,auto,auto,60,100,60,100,60,auto,60,60"
        }
      },
      "seq": 180,
      "void": false
    },
    {
      "from": null,
      "id": 180,
      "name": "div",
      "parent": 176,
      "props": {
        "children": {
          "type": "value",
          "value": "ยาที่ใช้ในปัจจุบัน (ต่อ)",
          "valueEN": "Current Medication (Continue)"
        },
        "id": {
          "type": "value",
          "value": "CardMedReconcileUX-div-180"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bolder\", fontSize: \"larger\",margin: \"20px 0px 5px 0px\"}"
        }
      },
      "seq": 181,
      "void": false
    },
    {
      "from": "react-lib/frameworks/Table",
      "id": 181,
      "name": "Table",
      "parent": 176,
      "props": {
        "data": {
          "type": "code",
          "value": "props.transferContData"
        },
        "getTdProps": {
          "type": "code",
          "value": "props.transferContTdProps"
        },
        "getTrProps": {
          "type": "code",
          "value": "props.transferContTrProps"
        },
        "headers": {
          "type": "value",
          "value": "TYPE,รหัสยา,ชื่อยาและความแรง,วิธีใช้,QTY,Start Date,Time,Last Date,Time,Note,Off,Hold,Cont"
        },
        "id": {
          "type": "value",
          "value": "CardMedReconcileUX-Table-181"
        },
        "keys": {
          "type": "value",
          "value": "type, code, name, label, quantity, startDate, startTime, lastDoseDate, lastDoseTime,noteIcon,off,hold,continue"
        },
        "minRows": {
          "type": "value",
          "value": "5"
        },
        "showPagination": {
          "type": "code",
          "value": "false"
        },
        "widths": {
          "type": "value",
          "value": "80,100,auto,auto,60,100,60,100,60,auto,60,60,80"
        }
      },
      "seq": 182,
      "void": false
    },
    {
      "from": null,
      "id": 182,
      "name": "div",
      "parent": 176,
      "props": {
        "children": {
          "type": "value",
          "value": "ยาที่ใช้ในปัจจุบัน (1 วัน)",
          "valueEN": "Current Medication (One Day)"
        },
        "id": {
          "type": "value",
          "value": "CardMedReconcileUX-div-182"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bolder\", fontSize: \"larger\", margin: \"20px 0px 5px 0px\"}"
        }
      },
      "seq": 179,
      "void": false
    },
    {
      "from": null,
      "id": 183,
      "name": "div",
      "parent": 11,
      "props": {
        "children": {
          "type": "code",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui form search-order-history"
        },
        "id": {
          "type": "value",
          "value": "CardMedReconcileUX-div-183"
        },
        "style": {
          "type": "code",
          "value": "{ marginTop: \"1rem\"  }"
        }
      },
      "seq": 183,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 184,
      "name": "FormGroup",
      "parent": 183,
      "props": {
        "id": {
          "type": "value",
          "value": "CardMedReconcileUX-FormGroup-184"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "widths": {
          "type": "code",
          "value": "16"
        }
      },
      "seq": 184,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 185,
      "name": "FormField",
      "parent": 184,
      "props": {
        "id": {
          "type": "value",
          "value": "CardMedReconcileUX-FormField-185"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 185,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 186,
      "name": "FormField",
      "parent": 184,
      "props": {
        "id": {
          "type": "value",
          "value": "CardMedReconcileUX-FormField-186"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "4"
        }
      },
      "seq": 186,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 187,
      "name": "FormField",
      "parent": 184,
      "props": {
        "id": {
          "type": "value",
          "value": "CardMedReconcileUX-FormField-187"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 187,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 188,
      "name": "FormField",
      "parent": 184,
      "props": {
        "id": {
          "type": "value",
          "value": "CardMedReconcileUX-FormField-188"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "4"
        }
      },
      "seq": 188,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 189,
      "name": "FormField",
      "parent": 184,
      "props": {
        "id": {
          "type": "value",
          "value": "CardMedReconcileUX-FormField-189"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 189,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 190,
      "name": "FormField",
      "parent": 184,
      "props": {
        "id": {
          "type": "value",
          "value": "CardMedReconcileUX-FormField-190"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 190,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 191,
      "name": "FormField",
      "parent": 184,
      "props": {
        "id": {
          "type": "value",
          "value": "CardMedReconcileUX-FormField-191"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 191,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 192,
      "name": "FormField",
      "parent": 184,
      "props": {
        "id": {
          "type": "value",
          "value": "CardMedReconcileUX-FormField-192"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 192,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 193,
      "name": "Button",
      "parent": 192,
      "props": {
        "children": {
          "type": "value",
          "value": "ค้นหา",
          "valueEN": "Search"
        },
        "color": {
          "type": "value",
          "value": "blue"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardMedReconcileUX-Button-193"
        },
        "loading": {
          "type": "code",
          "value": "props.medReconcileLoading"
        },
        "onClick": {
          "type": "code",
          "value": "props.onSearchOrderHistory"
        },
        "size": {
          "type": "value",
          "value": "tiny"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 193,
      "void": false
    },
    {
      "from": null,
      "id": 194,
      "name": "div",
      "parent": 191,
      "props": {
        "children": {
          "type": "code",
          "value": "props.endDateInternal"
        },
        "id": {
          "type": "value",
          "value": "CardMedReconcileUX-div-194"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 194,
      "void": false
    },
    {
      "from": null,
      "id": 195,
      "name": "div",
      "parent": 190,
      "props": {
        "children": {
          "type": "code",
          "value": "props.startDateInternal"
        },
        "id": {
          "type": "value",
          "value": "CardMedReconcileUX-div-195"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 195,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 196,
      "name": "Checkbox",
      "parent": 185,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.checkedDoctor"
        },
        "id": {
          "type": "value",
          "value": "CardMedReconcileUX-Checkbox-196"
        },
        "label": {
          "type": "value",
          "value": "ชื่อหรือรหัสแพทย์",
          "valueEN": "Physician name or code"
        },
        "onChange": {
          "type": "code",
          "value": "props.changeCheckedDoctor"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\", minWidth: \"max-content\"}"
        }
      },
      "seq": 196,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 197,
      "name": "Checkbox",
      "parent": 187,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.checkedDrug"
        },
        "id": {
          "type": "value",
          "value": "CardMedReconcileUX-Checkbox-197"
        },
        "label": {
          "type": "value",
          "value": "ชื่อหรือรหัสยา",
          "valueEN": "Drug name or code"
        },
        "onChange": {
          "type": "code",
          "value": "props.changeCheckedDrug"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\",minWidth: \"max-content\"}"
        }
      },
      "seq": 197,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 198,
      "name": "Checkbox",
      "parent": 189,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.checkedDateInternal"
        },
        "id": {
          "type": "value",
          "value": "CardMedReconcileUX-Checkbox-198"
        },
        "label": {
          "type": "value",
          "value": "วันที่สั่งยา",
          "valueEN": "Date of prescription"
        },
        "onChange": {
          "type": "code",
          "value": "props.changeCheckedDateInternal"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\",minWidth: \"max-content\"}"
        }
      },
      "seq": 198,
      "void": false
    },
    {
      "from": null,
      "id": 199,
      "name": "div",
      "parent": 186,
      "props": {
        "children": {
          "type": "code",
          "value": "props.searchDoctor"
        },
        "id": {
          "type": "value",
          "value": "CardMedReconcileUX-div-199"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 219,
      "void": false
    },
    {
      "from": null,
      "id": 200,
      "name": "div",
      "parent": 188,
      "props": {
        "children": {
          "type": "code",
          "value": "props.searchDrug"
        },
        "id": {
          "type": "value",
          "value": "CardMedReconcileUX-div-200"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 200,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 201,
      "name": "Form",
      "parent": 11,
      "props": {
        "id": {
          "type": "value",
          "value": "CardMedReconcileUX-Form-201"
        }
      },
      "seq": 201,
      "void": false
    },
    {
      "from": "react-lib/frameworks/Table",
      "id": 202,
      "name": "Table",
      "parent": 201,
      "props": {
        "data": {
          "type": "code",
          "value": "props.drugOrderHistoryItems"
        },
        "getTrProps": {
          "type": "code",
          "value": "props.drugOrderHistoryTrProps"
        },
        "headers": {
          "type": "value",
          "value": ",รหัสยา,ชื่อยา,จำนวนจ่าย,แพทย์,วันที่,หน่วยงาน"
        },
        "id": {
          "type": "value",
          "value": "CardMedReconcileUX-Table-202"
        },
        "keys": {
          "type": "value",
          "value": "_add,code,product_name,quantity,order_by_name,order_time,order_div_name"
        },
        "minRows": {
          "type": "code",
          "value": "5"
        },
        "showPagination": {
          "type": "code",
          "value": "false"
        },
        "style": {
          "type": "code",
          "value": "{height:\"250px\"}"
        },
        "widths": {
          "type": "value",
          "value": "^50,^100,^200,^90,^100,^90,^100"
        }
      },
      "seq": 202,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 203,
      "name": "Form",
      "parent": 11,
      "props": {
        "id": {
          "type": "value",
          "value": "CardMedReconcileUX-Form-203"
        }
      },
      "seq": 203,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 205,
      "name": "FormGroup",
      "parent": 203,
      "props": {
        "id": {
          "type": "value",
          "value": "CardMedReconcileUX-FormGroup-205"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{marginTop: \"1rem\"}"
        },
        "widths": {
          "type": "code",
          "value": "16"
        }
      },
      "seq": 205,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 206,
      "name": "FormField",
      "parent": 205,
      "props": {
        "id": {
          "type": "value",
          "value": "CardMedReconcileUX-FormField-206"
        },
        "style": {
          "type": "code",
          "value": "{flex:1}"
        }
      },
      "seq": 206,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 207,
      "name": "FormField",
      "parent": 205,
      "props": {
        "id": {
          "type": "value",
          "value": "CardMedReconcileUX-FormField-207"
        }
      },
      "seq": 207,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 208,
      "name": "Button",
      "parent": 207,
      "props": {
        "children": {
          "type": "value",
          "value": "เพิ่ม",
          "valueEN": "Add"
        },
        "color": {
          "type": "value",
          "value": "green"
        },
        "disabled": {
          "type": "code",
          "value": "props.disabledAddFromInternal"
        },
        "id": {
          "type": "value",
          "value": "CardMedReconcileUX-Button-208"
        },
        "onClick": {
          "type": "code",
          "value": "props.onAddInternalItem"
        }
      },
      "seq": 208,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 219,
      "name": "Form",
      "parent": 6,
      "props": {
        "id": {
          "type": "value",
          "value": "CardMedReconcileUX-Form-219"
        }
      },
      "seq": 219,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 220,
      "name": "FormGroup",
      "parent": 219,
      "props": {
        "id": {
          "type": "value",
          "value": "CardMedReconcileUX-FormGroup-220"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{padding: \"0 4rem 0 2rem\"}"
        },
        "widths": {
          "type": "code",
          "value": "16"
        }
      },
      "seq": 220,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 221,
      "name": "FormGroup",
      "parent": 219,
      "props": {
        "id": {
          "type": "value",
          "value": "CardMedReconcileUX-FormGroup-221"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{padding: \"0 4rem 0 2rem\"}"
        },
        "widths": {
          "type": "code",
          "value": "16"
        }
      },
      "seq": 221,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 222,
      "name": "FormGroup",
      "parent": 219,
      "props": {
        "id": {
          "type": "value",
          "value": "CardMedReconcileUX-FormGroup-222"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{padding: \"0 4rem 0 2rem\"}"
        },
        "widths": {
          "type": "code",
          "value": "16"
        }
      },
      "seq": 222,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 223,
      "name": "FormGroup",
      "parent": 219,
      "props": {
        "id": {
          "type": "value",
          "value": "CardMedReconcileUX-FormGroup-223"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{padding: \"0 4rem 0 2rem\"}"
        },
        "widths": {
          "type": "code",
          "value": "16"
        }
      },
      "seq": 223,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 224,
      "name": "FormGroup",
      "parent": 219,
      "props": {
        "id": {
          "type": "value",
          "value": "CardMedReconcileUX-FormGroup-224"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{padding: \"0 4rem 0 2rem\"}"
        },
        "widths": {
          "type": "code",
          "value": "16"
        }
      },
      "seq": 224,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 225,
      "name": "FormGroup",
      "parent": 219,
      "props": {
        "id": {
          "type": "value",
          "value": "CardMedReconcileUX-FormGroup-225"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{padding: \"0 4rem 0 2rem\"}"
        },
        "widths": {
          "type": "code",
          "value": "16"
        }
      },
      "seq": 225,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 226,
      "name": "FormGroup",
      "parent": 219,
      "props": {
        "id": {
          "type": "value",
          "value": "CardMedReconcileUX-FormGroup-226"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{marginTop: \"3rem\"}"
        },
        "widths": {
          "type": "code",
          "value": "16"
        }
      },
      "seq": 226,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 227,
      "name": "FormField",
      "parent": 220,
      "props": {
        "id": {
          "type": "value",
          "value": "CardMedReconcileUX-FormField-227"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "7"
        }
      },
      "seq": 227,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 228,
      "name": "FormField",
      "parent": 220,
      "props": {
        "id": {
          "type": "value",
          "value": "CardMedReconcileUX-FormField-228"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "9"
        }
      },
      "seq": 228,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 229,
      "name": "FormField",
      "parent": 221,
      "props": {
        "id": {
          "type": "value",
          "value": "CardMedReconcileUX-FormField-229"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "7"
        }
      },
      "seq": 229,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 230,
      "name": "FormField",
      "parent": 221,
      "props": {
        "id": {
          "type": "value",
          "value": "CardMedReconcileUX-FormField-230"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": ""
        },
        "width": {
          "type": "code",
          "value": "9"
        }
      },
      "seq": 230,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 231,
      "name": "FormField",
      "parent": 222,
      "props": {
        "id": {
          "type": "value",
          "value": "CardMedReconcileUX-FormField-231"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "7"
        }
      },
      "seq": 231,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 232,
      "name": "FormField",
      "parent": 222,
      "props": {
        "id": {
          "type": "value",
          "value": "CardMedReconcileUX-FormField-232"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "9"
        }
      },
      "seq": 232,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 233,
      "name": "FormField",
      "parent": 223,
      "props": {
        "id": {
          "type": "value",
          "value": "CardMedReconcileUX-FormField-233"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "7"
        }
      },
      "seq": 233,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 234,
      "name": "FormField",
      "parent": 223,
      "props": {
        "id": {
          "type": "value",
          "value": "CardMedReconcileUX-FormField-234"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "9"
        }
      },
      "seq": 234,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 235,
      "name": "FormField",
      "parent": 224,
      "props": {
        "id": {
          "type": "value",
          "value": "CardMedReconcileUX-FormField-235"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "7"
        }
      },
      "seq": 235,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 236,
      "name": "FormField",
      "parent": 224,
      "props": {
        "id": {
          "type": "value",
          "value": "CardMedReconcileUX-FormField-236"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": ""
        },
        "width": {
          "type": "code",
          "value": "9"
        }
      },
      "seq": 236,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 237,
      "name": "FormField",
      "parent": 225,
      "props": {
        "id": {
          "type": "value",
          "value": "CardMedReconcileUX-FormField-237"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{marginRight: \"4rem\"}"
        },
        "width": {
          "type": "code",
          "value": "5"
        }
      },
      "seq": 237,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 238,
      "name": "FormField",
      "parent": 225,
      "props": {
        "id": {
          "type": "value",
          "value": "CardMedReconcileUX-FormField-238"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "4"
        }
      },
      "seq": 238,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 239,
      "name": "FormField",
      "parent": 225,
      "props": {
        "id": {
          "type": "value",
          "value": "CardMedReconcileUX-FormField-239"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "4"
        }
      },
      "seq": 239,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 240,
      "name": "FormField",
      "parent": 226,
      "props": {
        "id": {
          "type": "value",
          "value": "CardMedReconcileUX-FormField-240"
        },
        "style": {
          "type": "code",
          "value": "{flex:1}"
        }
      },
      "seq": 240,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 241,
      "name": "FormField",
      "parent": 226,
      "props": {
        "id": {
          "type": "value",
          "value": "CardMedReconcileUX-FormField-241"
        }
      },
      "seq": 241,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 242,
      "name": "FormField",
      "parent": 226,
      "props": {
        "id": {
          "type": "value",
          "value": "CardMedReconcileUX-FormField-242"
        }
      },
      "seq": 242,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 243,
      "name": "FormField",
      "parent": 226,
      "props": {
        "id": {
          "type": "value",
          "value": "CardMedReconcileUX-FormField-243"
        }
      },
      "seq": 243,
      "void": false
    },
    {
      "from": null,
      "id": 245,
      "name": "div",
      "parent": 227,
      "props": {
        "children": {
          "type": "value",
          "value": "แพทย์",
          "valueEN": "physician"
        },
        "id": {
          "type": "value",
          "value": "CardMedReconcileUX-div-245"
        },
        "style": {
          "type": "code",
          "value": "{width: \"170px\"}"
        }
      },
      "seq": 245,
      "void": false
    },
    {
      "from": null,
      "id": 246,
      "name": "div",
      "parent": 227,
      "props": {
        "children": {
          "type": "code",
          "value": "props.doctor"
        },
        "id": {
          "type": "value",
          "value": "CardMedReconcileUX-div-246"
        },
        "style": {
          "type": "code",
          "value": "{  borderRadius: \"3px\",padding: \"5px 5px 5px 10px\", backgroundColor: \"#eeeeee\",width: \"100%\", minHeight: \"34px\"}"
        }
      },
      "seq": 246,
      "void": false
    },
    {
      "from": null,
      "id": 247,
      "name": "div",
      "parent": 228,
      "props": {
        "children": {
          "type": "value",
          "value": "หมายเหตุ",
          "valueEN": "note"
        },
        "id": {
          "type": "value",
          "value": "CardMedReconcileUX-div-247"
        },
        "style": {
          "type": "code",
          "value": "{padding: \"0 0.75rem 0 2rem\"}"
        }
      },
      "seq": 247,
      "void": false
    },
    {
      "from": null,
      "id": 248,
      "name": "div",
      "parent": 228,
      "props": {
        "children": {
          "type": "code",
          "value": "props.doctorRemark"
        },
        "id": {
          "type": "value",
          "value": "CardMedReconcileUX-div-248"
        },
        "style": {
          "type": "code",
          "value": "{  borderRadius: \"3px\",padding: \"5px 5px 5px 10px\", backgroundColor: \"#eeeeee\",width: \"100%\", minHeight: \"34px\"}"
        }
      },
      "seq": 248,
      "void": false
    },
    {
      "from": null,
      "id": 249,
      "name": "div",
      "parent": 229,
      "props": {
        "children": {
          "type": "value",
          "value": "เภสัชกร",
          "valueEN": "pharmacist"
        },
        "id": {
          "type": "value",
          "value": "CardMedReconcileUX-div-249"
        },
        "style": {
          "type": "code",
          "value": "{width: \"170px\"}"
        }
      },
      "seq": 249,
      "void": false
    },
    {
      "from": null,
      "id": 250,
      "name": "div",
      "parent": 229,
      "props": {
        "children": {
          "type": "code",
          "value": "props.pharmacist"
        },
        "id": {
          "type": "value",
          "value": "CardMedReconcileUX-div-250"
        },
        "style": {
          "type": "code",
          "value": "{  borderRadius: \"3px\",padding: \"5px 5px 5px 10px\", backgroundColor: \"#eeeeee\",width: \"100%\", minHeight: \"34px\"}"
        }
      },
      "seq": 250,
      "void": false
    },
    {
      "from": null,
      "id": 251,
      "name": "div",
      "parent": 230,
      "props": {
        "children": {
          "type": "value",
          "value": "หมายเหตุ",
          "valueEN": "note"
        },
        "id": {
          "type": "value",
          "value": "CardMedReconcileUX-div-251"
        },
        "style": {
          "type": "code",
          "value": "{padding: \"0 0.75rem 0 2rem\"}"
        }
      },
      "seq": 251,
      "void": false
    },
    {
      "from": null,
      "id": 252,
      "name": "div",
      "parent": 230,
      "props": {
        "children": {
          "type": "code",
          "value": "props.pharmacistRemark"
        },
        "className": {
          "type": "code",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardMedReconcileUX-div-252"
        },
        "style": {
          "type": "code",
          "value": "{  borderRadius: \"3px\",padding: \"5px 5px 5px 10px\", backgroundColor: \"#eeeeee\",width: \"100%\", minHeight: \"34px\"}"
        }
      },
      "seq": 252,
      "void": false
    },
    {
      "from": null,
      "id": 253,
      "name": "div",
      "parent": 231,
      "props": {
        "children": {
          "type": "value",
          "value": "พยาบาล OPD",
          "valueEN": "OPD Nurse"
        },
        "id": {
          "type": "value",
          "value": "CardMedReconcileUX-div-253"
        },
        "style": {
          "type": "code",
          "value": "{width: \"170px\"}"
        }
      },
      "seq": 253,
      "void": false
    },
    {
      "from": null,
      "id": 254,
      "name": "div",
      "parent": 231,
      "props": {
        "children": {
          "type": "code",
          "value": "props.nurseOPD"
        },
        "id": {
          "type": "value",
          "value": "CardMedReconcileUX-div-254"
        },
        "style": {
          "type": "code",
          "value": "{  borderRadius: \"3px\",padding: \"5px 5px 5px 10px\", backgroundColor: \"#eeeeee\",width: \"100%\", minHeight: \"34px\"}"
        }
      },
      "seq": 254,
      "void": false
    },
    {
      "from": null,
      "id": 255,
      "name": "div",
      "parent": 232,
      "props": {
        "children": {
          "type": "value",
          "value": "หมายเหตุ",
          "valueEN": "note"
        },
        "id": {
          "type": "value",
          "value": "CardMedReconcileUX-div-255"
        },
        "style": {
          "type": "code",
          "value": "{padding: \"0 0.75rem 0 2rem\"}"
        }
      },
      "seq": 255,
      "void": false
    },
    {
      "from": null,
      "id": 256,
      "name": "div",
      "parent": 232,
      "props": {
        "children": {
          "type": "code",
          "value": "props.nurseOPDRemark"
        },
        "id": {
          "type": "value",
          "value": "CardMedReconcileUX-div-256"
        },
        "style": {
          "type": "code",
          "value": "{  borderRadius: \"3px\",padding: \"5px 5px 5px 10px\", backgroundColor: \"#eeeeee\",width: \"100%\", minHeight: \"34px\"}"
        }
      },
      "seq": 256,
      "void": false
    },
    {
      "from": null,
      "id": 257,
      "name": "div",
      "parent": 233,
      "props": {
        "children": {
          "type": "value",
          "value": "พยาบาล IPD",
          "valueEN": "IPD Nurse"
        },
        "id": {
          "type": "value",
          "value": "CardMedReconcileUX-div-257"
        },
        "style": {
          "type": "code",
          "value": "{width: \"170px\"}"
        }
      },
      "seq": 257,
      "void": false
    },
    {
      "from": null,
      "id": 258,
      "name": "div",
      "parent": 233,
      "props": {
        "children": {
          "type": "code",
          "value": "props.nurseIPD"
        },
        "id": {
          "type": "value",
          "value": "CardMedReconcileUX-div-258"
        },
        "style": {
          "type": "code",
          "value": "{  borderRadius: \"3px\",padding: \"5px 5px 5px 10px\", backgroundColor: \"#eeeeee\",width: \"100%\", minHeight: \"34px\"}"
        }
      },
      "seq": 258,
      "void": false
    },
    {
      "from": null,
      "id": 259,
      "name": "div",
      "parent": 234,
      "props": {
        "children": {
          "type": "value",
          "value": "หมายเหตุ",
          "valueEN": "note"
        },
        "id": {
          "type": "value",
          "value": "CardMedReconcileUX-div-259"
        },
        "style": {
          "type": "code",
          "value": "{padding: \"0 0.75rem 0 2rem\"}"
        }
      },
      "seq": 259,
      "void": false
    },
    {
      "from": null,
      "id": 260,
      "name": "div",
      "parent": 234,
      "props": {
        "children": {
          "type": "code",
          "value": "props.nurseIPDRemark"
        },
        "id": {
          "type": "value",
          "value": "CardMedReconcileUX-div-260"
        },
        "style": {
          "type": "code",
          "value": "{  borderRadius: \"3px\",padding: \"5px 5px 5px 10px\", backgroundColor: \"#eeeeee\",width: \"100%\", minHeight: \"34px\"}"
        }
      },
      "seq": 260,
      "void": false
    },
    {
      "from": null,
      "id": 261,
      "name": "div",
      "parent": 235,
      "props": {
        "children": {
          "type": "value",
          "value": "ผู้บันทึกข้อมูลล่าสุด",
          "valueEN": "Latest recorder"
        },
        "id": {
          "type": "value",
          "value": "CardMedReconcileUX-div-261"
        },
        "style": {
          "type": "code",
          "value": "{width: \"170px\"}"
        }
      },
      "seq": 261,
      "void": false
    },
    {
      "from": null,
      "id": 262,
      "name": "div",
      "parent": 235,
      "props": {
        "children": {
          "type": "code",
          "value": "props.editUser"
        },
        "id": {
          "type": "value",
          "value": "CardMedReconcileUX-div-262"
        },
        "style": {
          "type": "code",
          "value": "{  borderRadius: \"3px\",padding: \"5px 5px 5px 10px\", backgroundColor: \"#eeeeee\",width: \"100%\", minHeight: \"34px\"}"
        }
      },
      "seq": 262,
      "void": false
    },
    {
      "from": null,
      "id": 263,
      "name": "div",
      "parent": 236,
      "props": {
        "children": {
          "type": "value",
          "value": "วันเวลาที่บันทึกล่าสุด",
          "valueEN": "Last recorded date"
        },
        "id": {
          "type": "value",
          "value": "CardMedReconcileUX-div-263"
        },
        "style": {
          "type": "code",
          "value": "{padding: \"0 0.75rem 0 50px\", minWidth: \"max-content\"}"
        }
      },
      "seq": 263,
      "void": false
    },
    {
      "from": null,
      "id": 264,
      "name": "div",
      "parent": 236,
      "props": {
        "children": {
          "type": "code",
          "value": "props.editDate"
        },
        "id": {
          "type": "value",
          "value": "CardMedReconcileUX-div-264"
        },
        "style": {
          "type": "code",
          "value": "{  borderRadius: \"3px\",padding: \"5px 5px 5px 10px\", backgroundColor: \"#eeeeee\", minHeight: \"34px\", width: \"175px\", minWidth: \"max-content\"}"
        }
      },
      "seq": 264,
      "void": false
    },
    {
      "from": null,
      "id": 265,
      "name": "div",
      "parent": 237,
      "props": {
        "children": {
          "type": "value",
          "value": "หมายเหตุ",
          "valueEN": "note"
        },
        "id": {
          "type": "value",
          "value": "CardMedReconcileUX-div-265"
        },
        "style": {
          "type": "code",
          "value": "{width: \"calc(170px - -1rem)\"}"
        }
      },
      "seq": 265,
      "void": false
    },
    {
      "from": null,
      "id": 266,
      "name": "div",
      "parent": 238,
      "props": {
        "children": {
          "type": "value",
          "value": "ชื่อผู้ใช้",
          "valueEN": "Username"
        },
        "id": {
          "type": "value",
          "value": "CardMedReconcileUX-div-266"
        }
      },
      "seq": 266,
      "void": false
    },
    {
      "from": null,
      "id": 267,
      "name": "div",
      "parent": 239,
      "props": {
        "children": {
          "type": "value",
          "value": "รหัสผ่าน",
          "valueEN": "Password"
        },
        "id": {
          "type": "value",
          "value": "CardMedReconcileUX-div-267"
        }
      },
      "seq": 267,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 268,
      "name": "Input",
      "parent": 237,
      "props": {
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardMedReconcileUX-Input-268"
        },
        "name": {
          "type": "value",
          "value": "remark"
        },
        "onChange": {
          "type": "code",
          "value": "props.changeRemark"
        },
        "onKeyDown": {
          "type": "code",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": ""
        },
        "value": {
          "type": "code",
          "value": "props.remark"
        }
      },
      "seq": 268,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 269,
      "name": "Input",
      "parent": 238,
      "props": {
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardMedReconcileUX-Input-269"
        },
        "name": {
          "type": "value",
          "value": "username"
        },
        "onChange": {
          "type": "code",
          "value": "props.changeUsername"
        },
        "onKeyDown": {
          "type": "code",
          "value": "props.keyDownInput"
        },
        "value": {
          "type": "code",
          "value": "props.username"
        }
      },
      "seq": 269,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 270,
      "name": "Input",
      "parent": 239,
      "props": {
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardMedReconcileUX-Input-270"
        },
        "name": {
          "type": "value",
          "value": "password"
        },
        "onChange": {
          "type": "code",
          "value": "props.changePassword"
        },
        "onKeyDown": {
          "type": "code",
          "value": "props.keyDownInput"
        },
        "type": {
          "type": "value",
          "value": "password"
        },
        "value": {
          "type": "code",
          "value": "props.password"
        }
      },
      "seq": 270,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 273,
      "name": "Button",
      "parent": 243,
      "props": {
        "children": {
          "type": "value",
          "value": "รับทราบและสั่งซื้อ",
          "valueEN": "ACKNOWLEDGE & ORDER"
        },
        "color": {
          "type": "value",
          "value": "blue"
        },
        "disabled": {
          "type": "code",
          "value": "props.disabledOrderButton"
        },
        "id": {
          "type": "value",
          "value": "CardMedReconcileUX-Button-273"
        },
        "onClick": {
          "type": "code",
          "value": "props.onOrder"
        },
        "style": {
          "type": "code",
          "value": "{...(!!props.hideAckOrderBtn && {display: \"none\"})}"
        },
        "type": {
          "type": "value",
          "value": "button"
        }
      },
      "seq": 273,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 274,
      "name": "Button",
      "parent": 242,
      "props": {
        "children": {
          "type": "value",
          "value": "บันทึกและรับทราบ",
          "valueEN": "SAVE & ACKNOWLEDGE"
        },
        "color": {
          "type": "value",
          "value": "green"
        },
        "disabled": {
          "type": "code",
          "value": "props.disabledSaveBtn"
        },
        "id": {
          "type": "value",
          "value": "CardMedReconcileUX-Button-274"
        },
        "onClick": {
          "type": "code",
          "value": "props.onSaveMedReconcile"
        },
        "type": {
          "type": "value",
          "value": "button"
        }
      },
      "seq": 274,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 275,
      "name": "Button",
      "parent": 241,
      "props": {
        "children": {
          "type": "value",
          "value": "บันทึกฉบับร่าง",
          "valueEN": "SAVE DRAFT"
        },
        "color": {
          "type": "value",
          "value": "yellow"
        },
        "id": {
          "type": "value",
          "value": "CardMedReconcileUX-Button-275"
        },
        "onClick": {
          "type": "code",
          "value": "props.onSaveDraft"
        },
        "style": {
          "type": "code",
          "value": "{...(props.hideSaveDraft && {display: \"none\"})}"
        },
        "type": {
          "type": "value",
          "value": "button"
        }
      },
      "seq": 275,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 279,
      "name": "Form",
      "parent": 57,
      "props": {
        "id": {
          "type": "value",
          "value": "CardMedReconcileUX-Form-279"
        }
      },
      "seq": 279,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 280,
      "name": "FormGroup",
      "parent": 279,
      "props": {
        "id": {
          "type": "value",
          "value": "CardMedReconcileUX-FormGroup-280"
        },
        "inline": {
          "type": "code",
          "value": ""
        },
        "widths": {
          "type": "code",
          "value": "16"
        }
      },
      "seq": 280,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 281,
      "name": "FormField",
      "parent": 280,
      "props": {
        "id": {
          "type": "value",
          "value": "CardMedReconcileUX-FormField-281"
        },
        "inline": {
          "type": "code",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{marginRight: \"0.55rem\"}"
        },
        "width": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 281,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 282,
      "name": "FormField",
      "parent": 280,
      "props": {
        "id": {
          "type": "value",
          "value": "CardMedReconcileUX-FormField-282"
        },
        "inline": {
          "type": "code",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{marginRight: \"0.55rem\"}"
        },
        "width": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 282,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 283,
      "name": "FormField",
      "parent": 280,
      "props": {
        "id": {
          "type": "value",
          "value": "CardMedReconcileUX-FormField-283"
        },
        "inline": {
          "type": "code",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{marginRight: \"0.55rem\"}"
        },
        "width": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 283,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 284,
      "name": "FormField",
      "parent": 280,
      "props": {
        "id": {
          "type": "value",
          "value": "CardMedReconcileUX-FormField-284"
        },
        "inline": {
          "type": "code",
          "value": ""
        },
        "width": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 284,
      "void": false
    },
    {
      "from": null,
      "id": 285,
      "name": "label",
      "parent": 281,
      "props": {
        "children": {
          "type": "value",
          "value": "วันที่เริ่มต้น",
          "valueEN": "Start Date"
        },
        "id": {
          "type": "value",
          "value": "CardMedReconcileUX-label-285"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"normal\"}"
        }
      },
      "seq": 285,
      "void": false
    },
    {
      "from": null,
      "id": 286,
      "name": "div",
      "parent": 281,
      "props": {
        "children": {
          "type": "code",
          "value": "props.startDateElement"
        },
        "id": {
          "type": "value",
          "value": "CardMedReconcileUX-div-286"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 286,
      "void": false
    },
    {
      "from": null,
      "id": 287,
      "name": "label",
      "parent": 282,
      "props": {
        "children": {
          "type": "value",
          "value": "เวลา",
          "valueEN": "Time"
        },
        "id": {
          "type": "value",
          "value": "CardMedReconcileUX-label-287"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"normal\"}"
        }
      },
      "seq": 287,
      "void": false
    },
    {
      "from": null,
      "id": 288,
      "name": "label",
      "parent": 283,
      "props": {
        "children": {
          "type": "value",
          "value": "วันที่สุดท้าย",
          "valueEN": "Last Date"
        },
        "id": {
          "type": "value",
          "value": "CardMedReconcileUX-label-288"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"normal\"}"
        }
      },
      "seq": 288,
      "void": false
    },
    {
      "from": null,
      "id": 289,
      "name": "label",
      "parent": 284,
      "props": {
        "children": {
          "type": "value",
          "value": "เวลา",
          "valueEN": "Time"
        },
        "id": {
          "type": "value",
          "value": "CardMedReconcileUX-label-289"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"normal\"}"
        }
      },
      "seq": 289,
      "void": false
    },
    {
      "from": null,
      "id": 290,
      "name": "div",
      "parent": 282,
      "props": {
        "children": {
          "type": "code",
          "value": "props.StartTimeFreeTextBox"
        },
        "id": {
          "type": "value",
          "value": "CardMedReconcileUX-div-290"
        }
      },
      "seq": 290,
      "void": false
    },
    {
      "from": null,
      "id": 291,
      "name": "div",
      "parent": 283,
      "props": {
        "children": {
          "type": "code",
          "value": "props.endDateElement"
        },
        "id": {
          "type": "value",
          "value": "CardMedReconcileUX-div-291"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 291,
      "void": false
    },
    {
      "from": null,
      "id": 292,
      "name": "div",
      "parent": 284,
      "props": {
        "children": {
          "type": "code",
          "value": "props.EndTimeFreeTextBox"
        },
        "id": {
          "type": "value",
          "value": "CardMedReconcileUX-div-292"
        }
      },
      "seq": 292,
      "void": false
    },
    {
      "from": null,
      "id": 296,
      "name": "div",
      "parent": 236,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonLog"
        },
        "id": {
          "type": "value",
          "value": "CardMedReconcileUX-div-296"
        }
      },
      "seq": 296,
      "void": false
    },
    {
      "from": null,
      "id": 297,
      "name": "div",
      "parent": 236,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonPrintMedReconcile"
        },
        "id": {
          "type": "value",
          "value": "CardMedReconcileUX-div-297"
        }
      },
      "seq": 297,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 80,
  "isMounted": false,
  "memo": false,
  "name": "CardMedReconcileUX",
  "project": "IsHealth",
  "screenPropsDefault": {
    "external": true
  },
  "width": 80
}

*********************************************************************************** */
